var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-16",
    d: "M77.66,250.32c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,195.37,77.66,250.32Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "28.07 229.79 31.33 230.01 134.18 170.59 132.55 169.41 28.07 229.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.55 169.41 31.33 227.91 31.33 94.73 132.55 36.23 132.55 169.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.44,29.67,28.07,92.85V235.66l109.37-63.19Zm-3.26,140.92L31.33,230V94.74L134.18,35.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.18 170.59 132.55 169.41 132.55 36.23 134.18 35.31 134.18 170.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.44 29.67 135.81 28.73 26.45 91.92 28.07 92.85 137.44 29.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.45 91.92 28.07 92.85 28.07 235.66 26.45 234.72 26.45 91.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.33 166.44 132.54 107.91 134.18 108.89 31.33 168.31 31.33 166.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.18 108.89 134.18 112.53 31.33 171.95 31.33 168.31 134.18 108.89",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blinds--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.33,140v4.34l102.07-59-.85-3.81Zm0-6.08v4.34l102.07-59-.85-3.81Zm0,12.15v4.35l102.07-59-.85-3.82Zm0,6.08v4.35l102.07-59-.85-3.82ZM132.55,39,31.33,97.46v4.34l102.07-59ZM31.33,109.62V114l102.07-59-.85-3.81Zm0,18.23v4.34l102.07-59-.85-3.82Zm0-12.16V120L133.4,61l-.85-3.82Zm0-12.15v4.34l102.07-59-.85-3.81Zm0,18.23v4.35l102.07-59-.85-3.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,39,31.33,97.46V99.2L132.89,40.49ZM31.33,103.54v1.74L132.89,46.56l-.34-1.51Zm0,6.08v1.74L132.89,52.64l-.34-1.51Zm0,6.07v1.75L132.89,58.72l-.34-1.52Zm0,6.08v1.75L132.89,64.8l-.34-1.52Zm0,6.08v1.75L132.89,70.88l-.34-1.52Zm0,6.08v1.74L132.89,77l-.34-1.51Zm0,6.08v1.74L132.89,83l-.34-1.51Zm0,6.07v1.75L132.89,89.11l-.34-1.52Zm0,6.08v1.75L132.89,95.19l-.34-1.52Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.77,49.93h0l0,0h0l4.31-2.5h0l.06,0h0C396.84,45,403.05,45.7,409.74,50c13.44,8.65,23.71,28.61,22.93,44.58-.39,8-3.44,13.42-8.08,15.82h0l0,0h0l-4.31,2.5h0l0,0h0c-4.65,2.36-10.86,1.67-17.56-2.64-13.44-8.65-23.7-28.61-22.93-44.57C380.08,57.8,383.14,52.34,387.77,49.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.58,112.76l4-2.32h0l.05,0c4.63-2.41,7.68-7.87,8.07-15.82.35-7.12-1.51-15-4.85-22.37l-4.31,2.5c3.35,7.34,5.19,15.25,4.85,22.37C428,104.88,425,110.27,420.58,112.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.62,110.33c-13.44-8.65-23.7-28.61-22.93-44.57S392,43.87,405.43,52.52s23.7,28.61,22.93,44.57S416.06,119,402.62,110.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.88,109.22c7.92.38,9.21-8.53,9.4-12.37.68-14.08-8.75-32.43-20.6-40.06a18.07,18.07,0,0,0-8.51-3.16c-7.92-.38-9.21,8.53-9.4,12.37-.69,14.08,8.75,32.43,20.6,40.06a18.07,18.07,0,0,0,8.51,3.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,84.07a.92.92,0,0,0,.28,0,.86.86,0,0,0,.58-.82V62.83a.86.86,0,1,0-1.72,0V80.69l-9.5-12.2a.87.87,0,0,0-1.37,1.06l11.05,14.18A.86.86,0,0,0,402.47,84.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.33,99.11a.3.3,0,0,0,.13,0,.35.35,0,0,0,.24-.45l-4.78-16.11a.36.36,0,0,0-.45-.24.36.36,0,0,0-.24.45L407,98.85A.39.39,0,0,0,407.33,99.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,79.13c-1.58-1-2.93-.32-3,1.56a6.5,6.5,0,0,0,2.69,5.24c1.58,1,2.94.32,3-1.56A6.52,6.52,0,0,0,402.74,79.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-16",
    d: "M120.37,448.31,20,390.41c-4.36-2.52-4.36-6.59,0-9.11L179.2,289.23a17.39,17.39,0,0,1,15.77,0l100.33,57.9c4.36,2.52,4.36,6.59,0,9.11L136.14,448.31A17.39,17.39,0,0,1,120.37,448.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M235.63,404.94c21.6,12.62,21.6,33.07,0,45.68s-56.64,12.62-78.24,0-21.61-33.06,0-45.68S214,392.33,235.63,404.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M81,423c11,6.45,11,16.91,0,23.36s-29,6.45-40,0S30,429.48,41,423,70,416.57,81,423Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M314.6,446a5.45,5.45,0,0,1-5.3-4.39l-.9-4.72a61.56,61.56,0,0,1-6-1.5l-9.19,4.26a6.17,6.17,0,0,1-2.59.55,6.32,6.32,0,0,1-3.15-.81l-9.4-5.43a4.65,4.65,0,0,1-.4-7.94l4.93-3.55c-.23-.34-.46-.68-.67-1l-11.48-.73a5.23,5.23,0,0,1-4.9-5.21v-7a5.23,5.23,0,0,1,4.9-5.21l11.48-.73c.21-.34.44-.69.67-1L277.65,398a4.65,4.65,0,0,1,.4-7.94l9.4-5.43a6.41,6.41,0,0,1,3.15-.8,6.25,6.25,0,0,1,2.6.55l9.18,4.25a58.82,58.82,0,0,1,6-1.49l.9-4.73a5.46,5.46,0,0,1,5.3-4.39h13.82a5.46,5.46,0,0,1,5.3,4.39l.9,4.73a58.18,58.18,0,0,1,6,1.49l9.19-4.26a6.32,6.32,0,0,1,2.59-.54,6.38,6.38,0,0,1,3.15.8L365,390a4.66,4.66,0,0,1,.4,8l-4.93,3.54c.24.34.46.69.67,1l11.48.73a5.25,5.25,0,0,1,4.9,5.22v7a5.23,5.23,0,0,1-4.89,5.21l-11.49.73c-.21.35-.43.69-.67,1l4.93,3.55a4.65,4.65,0,0,1-.4,7.94l-9.4,5.43a6.32,6.32,0,0,1-3.15.81h0a6.17,6.17,0,0,1-2.59-.55l-9.19-4.26a60.17,60.17,0,0,1-6,1.5l-.9,4.73a5.46,5.46,0,0,1-5.3,4.38Zm6.91-43a28.81,28.81,0,0,0-13.9,3.26C304.69,407.94,303,410,303,412s1.67,4,4.59,5.73a31.18,31.18,0,0,0,27.8,0C338.33,416,340,413.94,340,412s-1.67-4-4.59-5.73A28.78,28.78,0,0,0,321.51,403Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M410.74,462.4c-.21,0-.41,0-.62,0l-8.7-.91a5.77,5.77,0,0,1-5.13-6.43l.16-1.34c-.73-.27-1.45-.56-2.15-.86,0,0,0,0,0,0h-.1l-6.61,2.07a6.65,6.65,0,0,1-2,.3,7.36,7.36,0,0,1-4.64-1.61l-4.45-3.7a5.17,5.17,0,0,1,1-8.74l1.51-.75-4.08-.7a5.57,5.57,0,0,1-4.39-7.19l1.2-3.85a6.42,6.42,0,0,1,6-4.39l7.4.29-.95-1a5.22,5.22,0,0,1,1.89-8.55l7-2.78a7,7,0,0,1,2.6-.48,7.39,7.39,0,0,1,4.05,1.16l4.51,3h.05c1.3-.22,2.63-.39,4-.52l1.35-2.62a6.7,6.7,0,0,1,5.83-3.53,4.49,4.49,0,0,1,.64,0l8.69.9a5.77,5.77,0,0,1,5.13,6.43l-.16,1.34c.73.27,1.45.56,2.15.86,0,0,0,0,0,0h.1l6.61-2.07a6.65,6.65,0,0,1,2-.3,7.36,7.36,0,0,1,4.64,1.61l4.45,3.7a5.17,5.17,0,0,1-1,8.74l-1.5.75,4.08.7a5.57,5.57,0,0,1,4.39,7.19l-1.2,3.85a6.42,6.42,0,0,1-6,4.39l-7.4-.3.95,1a5.22,5.22,0,0,1-1.89,8.55l-7,2.79a7.15,7.15,0,0,1-2.6.47,7.39,7.39,0,0,1-4.05-1.16l-4.52-3h0c-1.29.22-2.62.39-4,.51l-1.34,2.63A6.7,6.7,0,0,1,410.74,462.4Zm2.3-31.94a21.47,21.47,0,0,0-7.88,1.41c-3.06,1.22-4.32,2.78-4.47,3.74s.82,1.93,1.42,2.42c2.33,1.94,6.53,3.15,11,3.15a21.48,21.48,0,0,0,7.89-1.41c3.06-1.22,4.32-2.78,4.47-3.75s-.82-1.92-1.42-2.41C421.68,431.67,417.47,430.46,413,430.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.16 235.09 462.29 387.01 462.29 384.54 199.16 232.62 199.16 235.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.12 228.03 199.16 232.62 462.29 384.54 470.25 379.95 207.12 228.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.25 379.95 462.29 384.54 462.29 387.01 470.25 382.42 470.25 379.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.12 228.03 470.25 379.95 470.25 179.99 207.12 28.07 207.12 228.03",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "207.12 228.03 470.25 379.95 470.25 179.99 207.12 28.07 207.12 228.03"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "463.23 366.53 463.23 185.3 214.14 41.49 214.14 222.72 463.23 366.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.23 361.34 463.23 366.52 214.15 222.72 214.15 41.48 218.66 44.09 218.66 220.13 463.23 361.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.23 366.53 470.25 379.95 207.12 228.03 214.14 222.72 463.23 366.53"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "214.14 41.49 207.12 28.07 470.25 179.99 463.23 185.3 214.14 41.49"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "476.37 176.46 470.25 179.99 470.25 379.95 476.37 376.41 476.37 176.46",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.37 176.46 470.25 179.99 470.25 379.95 476.37 376.41 476.37 176.46"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "207.12 28.07 213.24 24.54 476.37 176.46 470.25 179.99 207.12 28.07",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.12 28.07 213.24 24.54 476.37 176.46 470.25 179.99 207.12 28.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.61,225.91c1-.57-11.41-20.4-12.29-21.86-2.76-4.64-11.62-4.48-12.57,1.64A57.41,57.41,0,0,0,413,223c-7.07-16.38-12.77-33.52-22.08-48.74-3.25-5.33-13.71-3.69-12.81,3.47,2.19,17.46,6.83,34.24,12.09,50.85-9.94-26.65-16.72-54.76-22-81.56-1.49-7.6-13.85-5.89-13.51,1.83a329.5,329.5,0,0,0,5.61,48.11C357.88,191,355.59,185,353.32,179c-3.09-8.16-15.39-5.11-13.27,3.65q1.21,5,2.42,10c-3.25-7.62-6.43-15.27-9.47-23-2.57-6.48-14.64-6.53-13.51,1.83.08.61.18,1.22.27,1.83h0a.5.5,0,0,1,0,.13q.66,4.48,1.5,8.91c-3.71-9.18-7.18-18.46-10.48-27.81-3.78-10.73-6-23.61-12.38-33.1a7,7,0,0,0-11.88,0c-5.55,8.77-2.23,18.81-.14,28.38A390.57,390.57,0,0,0,298,191.08q3.06,9.09,6.45,18c-3.6-5.77-7.06-11.61-10.33-17.58-13.14-24-19.11-50.45-30.9-74.93-3-6.2-13-3.13-12.81,3.47.72,20.1,5.92,39,13.41,57.63,2.57,6.37,5.34,12.66,8.13,18.93q-12.68-18.27-24.15-37.4c-2.82-4.7-11.5-4.43-12.57,1.64a75.3,75.3,0,0,0,1.56,34.55c2.4,8.51,15.68,4.89,13.26-3.65-.47-1.66-.85-3.29-1.19-4.91A690.4,690.4,0,0,0,290.41,244c3.7,4.58,12.14.84,11.74-4.86a60.49,60.49,0,0,0-2-11.37c9.1,13.64,18.82,26.89,28.53,40.09,5.3,7.2,15.38,1.19,11.87-6.94-5.66-13.13-11.27-26.28-16.6-39.55a331.07,331.07,0,0,0,29,47.39c5.23,7.08,15.7,1.17,11.87-6.94q-3.1-6.57-6.17-13.19a7,7,0,0,0,9.29-3.53c2.37,4.08,4.83,8.12,7.5,12.05,3.31,4.87,9.09,3.95,11.63-.12A234.73,234.73,0,0,0,411,297.82c4.56,6.15,14.23,2.68,12.57-5.3-3.06-14.64-7.6-28.89-12.34-43.08a115.65,115.65,0,0,0,9.38,14.05c3.86,4.94,11.67.58,11.74-4.86.1-7.77-1.84-15.45-3.66-23.1,4.35,4.07,9.55,5.84,15.9,2.25C452.27,233.43,445.34,221.55,437.61,225.91Z",
    style: {
      fill: "#fff",
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,342.07a5.1,5.1,0,0,1,2.31-4,1.62,1.62,0,0,1,1.63-.16h0L429.4,353l-3.28,5.66L400,343.57h0A1.64,1.64,0,0,1,399.33,342.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.77,353.15a5.12,5.12,0,0,0-2.32,4c0,1.47,1,2.07,2.32,1.33a5.13,5.13,0,0,0,2.31-4C430.08,353,429,352.42,427.77,353.15Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Formulas--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.24,329.14a.25.25,0,0,1-.25-.25V249.14a.25.25,0,0,1,.5,0v79.75A.25.25,0,0,1,420.24,329.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.22,252.75a.25.25,0,0,1-.24-.18l-.79-2.7-.7,1.6a.26.26,0,0,1-.33.13.25.25,0,0,1-.12-.33l1-2.23c.05-.1.13-.18.25-.15a.26.26,0,0,1,.22.18l1,3.36a.25.25,0,0,1-.17.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.24,329.14h0A.23.23,0,0,1,420,329l-1-3.35a.27.27,0,0,1,.17-.32.26.26,0,0,1,.31.17l.79,2.71.7-1.61a.25.25,0,0,1,.33-.12.24.24,0,0,1,.13.33l-1,2.23A.24.24,0,0,1,420.24,329.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.15,306.53l-.12,0L390.21,272a.25.25,0,1,1,.25-.43l59.82,34.54a.25.25,0,0,1,.09.34A.25.25,0,0,1,450.15,306.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,274.51a.25.25,0,0,1-.19-.09l-2.1-2.51a.25.25,0,0,1,0-.26.23.23,0,0,1,.21-.15l2.1-.1a.25.25,0,0,1,.26.24.24.24,0,0,1-.24.26l-1.59.07,1.77,2.13a.25.25,0,0,1,0,.36A.3.3,0,0,1,392.43,274.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.05,306.63a.25.25,0,0,1,0-.5l1.6-.07-1.78-2.13a.25.25,0,0,1,0-.35.25.25,0,0,1,.36,0l2.09,2.51a.25.25,0,0,1,0,.26.24.24,0,0,1-.22.15l-2.09.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.29,294.1a.26.26,0,0,1-.25-.21.26.26,0,0,1,.2-.29l51.91-9.66a.24.24,0,0,1,.29.2.25.25,0,0,1-.2.29l-51.91,9.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.59,295.17a.18.18,0,0,1-.1,0l-2.31-1.07a.24.24,0,0,1-.13-.17.23.23,0,0,1,0-.21l1.33-1.75a.25.25,0,0,1,.35-.05.25.25,0,0,1,.05.35l-1.15,1.5,2,.95a.25.25,0,0,1,.12.33A.24.24,0,0,1,396.59,295.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,286.19a.26.26,0,0,1-.19-.41l1.14-1.5-2-.94a.25.25,0,0,1-.12-.34.25.25,0,0,1,.33-.12l2.3,1.08a.25.25,0,0,1,.14.16.29.29,0,0,1,0,.22l-1.34,1.75A.26.26,0,0,1,444.86,286.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,243.42l.39-.19c.46.43.86.83,1.32,1.35l.19-.38.31.09.07.11a1.75,1.75,0,0,1-.53.61c-.47.37-1,.61-1.43.93l.15.23a2.59,2.59,0,0,0,.8.86.49.49,0,0,0,.41.07,1.36,1.36,0,0,1-.16-.53c0-.24.12-.31.28-.25a1,1,0,0,1,.18.55.58.58,0,0,1-.89.57,2.46,2.46,0,0,1-.84-1l-.14-.31-.21.47-.32-.14-.05-.07a1.53,1.53,0,0,1,.46-.54c.48-.34,1-.62,1.5-1-.39-.39-.71-.69-1.15-1.08l-.24.88-.23-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.59,267.11l1.05.61a2,2,0,0,1,1,1.68c0,.83-.47,1.17-1.3.69l-.31-.19c-.06.39-.12.79-.17,1.19l.44.32,0,.23-1.24-.72,0-.22.39.16.27-1.74.21-1.47-.42-.31Zm.79.75-.27,1.76v0l.27.16c.59.34.88.06.88-.58a1.36,1.36,0,0,0-.68-1.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,271.52a2.27,2.27,0,0,1,1.51-2.44l.1.25a2.34,2.34,0,0,0-1.25,2.41,7.12,7.12,0,0,0,.5,2.51l-.16,0A6.86,6.86,0,0,1,431,271.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38,272.84c.1.05.16.13.24.35l.05.16.09-.06a4,4,0,0,0,.59-.69l-.19-1c-.06-.29-.09-.39-.19-.44s-.19-.05-.34.22l-.11-.17c.17-.4.38-.5.58-.39s.27.29.35.73l.14.77a4.87,4.87,0,0,1,.5-.65.27.27,0,0,1,.38-.06.75.75,0,0,1,.31.5c0,.18-.09.25-.19.19a.61.61,0,0,1-.26-.36l0-.06s0,0-.07.05a4.79,4.79,0,0,0-.59.67l.16.87c.07.38.13.48.26.56s.28,0,.44-.19l.12.18c-.22.31-.49.47-.74.33s-.24-.23-.31-.63l-.17-.86a4.22,4.22,0,0,1-.52.7.25.25,0,0,1-.33,0,.84.84,0,0,1-.37-.65C432.21,272.81,432.31,272.8,432.38,272.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.6,275.5a.71.71,0,0,0,.54-.34l-.13-.28a.86.86,0,0,1-.08-.36c0-.18.08-.31.28-.19a.79.79,0,0,1,.21.2.59.59,0,0,1,.05.27c0,.59-.36.93-.8.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.62,276.12a1.38,1.38,0,0,1,.37.43v0a1,1,0,0,0,.42-.21,1.7,1.7,0,0,0,.24-.23c0-.73-.09-1.18-.17-2s-.1-.92-.18-1-.14,0-.31.22l-.1-.15c.18-.42.39-.51.58-.4s.27.29.33,1,.08,1.38.1,2a5.8,5.8,0,0,0,.63-1.57c.16-.61.22-.7.35-.63a.34.34,0,0,1,.17.31.83.83,0,0,1-.11.43c-.1.21-.2.4-.37.72a9.37,9.37,0,0,1-.62,1,2.52,2.52,0,0,1-.43.52c-.3.26-.57.37-.84.22a.67.67,0,0,1-.32-.55C435.39,276.09,435.49,276.05,435.62,276.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.84,277.38a.73.73,0,0,0,.54-.35l-.12-.28a.83.83,0,0,1-.09-.36c0-.18.09-.3.29-.19a1.26,1.26,0,0,1,.21.2.9.9,0,0,1-.76,1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,274.9l.31-.15a11.48,11.48,0,0,1,1.09,1.11l.16-.31.25.07.06.09a1.33,1.33,0,0,1-.44.5,14,14,0,0,1-1.18.77l.13.19a2.25,2.25,0,0,0,.66.7.4.4,0,0,0,.34.06,1,1,0,0,1-.14-.44c0-.2.1-.25.23-.2a.72.72,0,0,1,.15.45.48.48,0,0,1-.73.47,2,2,0,0,1-.69-.84l-.11-.25-.18.38-.26-.11,0-.06a1.18,1.18,0,0,1,.38-.44c.39-.29.83-.52,1.23-.83-.32-.32-.58-.56-.95-.88l-.19.72-.19-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.76,277.39a2.27,2.27,0,0,1-1.51,2.44l-.1-.25a2.34,2.34,0,0,0,1.25-2.41,7.12,7.12,0,0,0-.5-2.51l.16,0A6.86,6.86,0,0,1,442.76,277.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,310.33a1.5,1.5,0,0,1,.45.52l0,0a1.24,1.24,0,0,0,.5-.25,1.53,1.53,0,0,0,.29-.28c0-.9-.11-1.44-.2-2.49s-.12-1.12-.22-1.18-.17,0-.37.28l-.13-.19c.22-.51.47-.62.71-.48s.33.34.39,1.22.11,1.69.13,2.39a7.16,7.16,0,0,0,.77-1.9c.18-.75.27-.86.42-.77a.45.45,0,0,1,.21.38,1,1,0,0,1-.14.52c-.12.25-.23.49-.45.88a12.12,12.12,0,0,1-.75,1.25,3.25,3.25,0,0,1-.52.64c-.37.31-.69.45-1,.26a.84.84,0,0,1-.4-.66C451.67,310.29,451.79,310.24,452,310.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.52,294.42c.12.06.19.15.29.43l.06.18A.34.34,0,0,0,390,295a4.53,4.53,0,0,0,.72-.83l-.24-1.2c-.06-.34-.1-.47-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.47-.61.7-.48s.33.36.43.9l.18.92a5.7,5.7,0,0,1,.6-.78.32.32,0,0,1,.46-.07.87.87,0,0,1,.37.61c0,.21-.1.29-.23.22s-.2-.16-.3-.43l0-.08-.08.07a6.3,6.3,0,0,0-.72.81l.2,1.06c.08.46.16.58.32.67s.33,0,.53-.22l.14.22c-.27.37-.6.56-.89.39s-.29-.27-.39-.76l-.2-1a4.32,4.32,0,0,1-.64.84.27.27,0,0,1-.39,0,1,1,0,0,1-.46-.79C389.31,294.38,389.44,294.36,389.52,294.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,185a.22.22,0,0,1-.13,0l-88.16-50.9a.26.26,0,0,1,.26-.46l88.17,50.91a.26.26,0,0,1,.09.36A.26.26,0,0,1,314,185Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,185.12a.27.27,0,0,1-.27-.25.28.28,0,0,1,.26-.28l1.68-.07-1.88-2.26a.27.27,0,0,1,.41-.34l2.22,2.67a.26.26,0,0,1,0,.27.28.28,0,0,1-.23.16l-2.22.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,191.93l-.06,0-11-6.33a.12.12,0,1,1,.12-.2l11,6.34a.1.1,0,0,1,0,.15A.11.11,0,0,1,298.71,191.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.07,192a.12.12,0,0,1-.12-.1.11.11,0,0,1,.11-.12l1.41-.07L297,189.92a.12.12,0,0,1,0-.16.11.11,0,0,1,.16,0l1.64,2a.11.11,0,0,1,0,.12.12.12,0,0,1-.1.07l-1.64.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.36,170.37l-.06,0-11-6.33a.11.11,0,0,1,.11-.2l11,6.34a.11.11,0,0,1,0,.15A.11.11,0,0,1,261.36,170.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,166a.12.12,0,0,1-.08,0l-1.64-2a.11.11,0,0,1,0-.12.14.14,0,0,1,.1-.07l1.64-.07h0a.12.12,0,1,1,0,.23l-1.41.06,1.49,1.79a.12.12,0,0,1,0,.16A.11.11,0,0,1,252,166Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,143.78a.11.11,0,0,1-.11-.12v-9.32a.11.11,0,0,1,.11-.11.11.11,0,0,1,.12.11v9.32A.12.12,0,0,1,311,143.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,137.08a.11.11,0,0,1-.11-.08l-.68-2.33-.64,1.46a.11.11,0,0,1-.15.06.12.12,0,0,1-.06-.15l.77-1.75a.11.11,0,0,1,.1-.06h0a.1.1,0,0,1,.1.08l.77,2.62a.12.12,0,0,1-.08.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,167a.11.11,0,0,1-.11-.11v-9.32a.11.11,0,0,1,.11-.12.12.12,0,0,1,.12.12v9.32A.11.11,0,0,1,311,167Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,167h0a.12.12,0,0,1-.11-.08l-.76-2.63a.12.12,0,0,1,.07-.14.13.13,0,0,1,.15.08l.67,2.33.64-1.46a.12.12,0,0,1,.15-.06.11.11,0,0,1,.06.15l-.76,1.74A.11.11,0,0,1,311,167Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,158.74a.26.26,0,0,1-.26-.27V78.25a.26.26,0,1,1,.52,0v80.22A.26.26,0,0,1,238,158.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.05,82.07a.27.27,0,0,1-.26-.19L238,79l-.74,1.69a.26.26,0,0,1-.35.13.26.26,0,0,1-.14-.34l1-2.36A.24.24,0,0,1,238,78a.26.26,0,0,1,.23.19l1,3.55a.27.27,0,0,1-.18.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.2,129.32a1.23,1.23,0,0,1-.63-.19,3.21,3.21,0,0,1-1.37-2.6,1.36,1.36,0,0,1,.56-1.24,1.06,1.06,0,0,1,1.08.07,3.21,3.21,0,0,1,1.37,2.6,1.36,1.36,0,0,1-.56,1.24A.89.89,0,0,1,299.2,129.32Zm-1-3.62a.45.45,0,0,0-.19,0,.9.9,0,0,0-.29.78,2.72,2.72,0,0,0,1.11,2.14.57.57,0,0,0,.55.07.91.91,0,0,0,.3-.78,2.7,2.7,0,0,0-1.12-2.14A.74.74,0,0,0,298.21,125.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.88,134a1.32,1.32,0,0,1-.63-.18,3.23,3.23,0,0,1-1.37-2.61,1.36,1.36,0,0,1,.56-1.24,1.08,1.08,0,0,1,1.08.07,3.23,3.23,0,0,1,1.37,2.61,1.36,1.36,0,0,1-.56,1.23A.89.89,0,0,1,250.88,134Zm-1-3.62a.45.45,0,0,0-.19,0,.9.9,0,0,0-.29.78,2.71,2.71,0,0,0,1.11,2.15.57.57,0,0,0,.55.06.88.88,0,0,0,.29-.77,2.71,2.71,0,0,0-1.11-2.15A.74.74,0,0,0,249.89,130.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,132.15a.27.27,0,0,1-.27-.24.28.28,0,0,1,.24-.29L298.68,127a.28.28,0,0,1,.29.24.27.27,0,0,1-.24.29l-48.32,4.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.41,92.7a.2.2,0,0,1-.13,0l-.4-.23a.26.26,0,0,1,.26-.46l.4.23a.27.27,0,0,1-.13.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,176.2a.26.26,0,0,1-.27-.26v-.46a.27.27,0,0,1,.53,0v.46A.26.26,0,0,1,298.71,176.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,160.05a.32.32,0,0,1-.14,0l-48.32-27.9a.27.27,0,0,1,.27-.46l48.32,27.9a.26.26,0,0,1-.13.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,164.87a.23.23,0,0,1-.14,0l-.38-.22a.26.26,0,1,1,.26-.46l.39.23a.26.26,0,0,1-.13.49Zm-.92-.53a.2.2,0,0,1-.13,0l-.8-.45a.28.28,0,0,1-.1-.37.26.26,0,0,1,.36-.09l.8.46a.26.26,0,0,1,.1.36A.28.28,0,0,1,306.14,164.34Zm-1.33-.77a.31.31,0,0,1-.13,0l-.8-.46a.27.27,0,1,1,.27-.46l.79.46a.26.26,0,0,1,.1.36A.26.26,0,0,1,304.81,163.57Zm-1.33-.76a.22.22,0,0,1-.13,0l-.8-.46a.27.27,0,0,1-.09-.36.26.26,0,0,1,.36-.1l.8.46a.28.28,0,0,1,.09.37A.28.28,0,0,1,303.48,162.81Zm-1.32-.77a.35.35,0,0,1-.14,0l-.79-.46a.26.26,0,1,1,.26-.46l.8.46a.27.27,0,0,1,.1.36A.28.28,0,0,1,302.16,162Zm-1.33-.76a.2.2,0,0,1-.13,0l-.8-.46a.26.26,0,0,1-.1-.36.27.27,0,0,1,.36-.1l.8.46a.27.27,0,0,1-.13.5Zm-1.33-.77a.22.22,0,0,1-.13,0l-.8-.45a.27.27,0,0,1-.09-.37.26.26,0,0,1,.36-.09l.79.46a.26.26,0,0,1,.1.36A.28.28,0,0,1,299.5,160.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14,131.43a.31.31,0,0,1-.13,0l-.51-.3a.26.26,0,0,1,.26-.46l.51.3a.26.26,0,0,1,.1.36A.26.26,0,0,1,249.14,131.43Zm-1-.6a.35.35,0,0,1-.14,0l-.79-.46a.28.28,0,0,1-.1-.37.27.27,0,0,1,.36-.09l.8.46a.27.27,0,0,1,.1.36A.28.28,0,0,1,248.1,130.83Zm-1.33-.77a.28.28,0,0,1-.13,0l-.8-.46a.26.26,0,0,1-.1-.36.28.28,0,0,1,.37-.1l.79.46a.26.26,0,0,1,.1.36A.26.26,0,0,1,246.77,130.06Zm-1.33-.76a.22.22,0,0,1-.13,0l-.8-.46a.26.26,0,0,1-.09-.36.25.25,0,0,1,.36-.09l.79.46a.26.26,0,0,1,.1.36A.28.28,0,0,1,245.44,129.3Zm-1.32-.77a.32.32,0,0,1-.14,0l-.79-.46a.26.26,0,1,1,.26-.46l.8.46a.27.27,0,0,1,.1.36A.26.26,0,0,1,244.12,128.53Zm-1.33-.76a.28.28,0,0,1-.13,0l-.8-.46a.26.26,0,0,1-.1-.36.27.27,0,0,1,.36-.1l.8.46a.27.27,0,0,1-.13.5Zm-1.33-.77a.22.22,0,0,1-.13,0l-.8-.45a.27.27,0,0,1-.09-.37.27.27,0,0,1,.36-.09l.79.46a.26.26,0,0,1,.1.36A.28.28,0,0,1,241.46,127Zm-1.33-.77a.31.31,0,0,1-.13,0l-.79-.46a.26.26,0,0,1,.26-.46l.8.46a.26.26,0,0,1,.09.36A.26.26,0,0,1,240.13,126.23Zm-1.32-.76a.25.25,0,0,1-.14,0l-.79-.46a.26.26,0,0,1,.26-.46l.8.46a.28.28,0,0,1,.1.36A.27.27,0,0,1,238.81,125.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,148.31a.27.27,0,0,1-.27-.27v-.7a.27.27,0,1,1,.53,0v.7A.27.27,0,0,1,250.39,148.31Zm0-1.32a.27.27,0,0,1-.27-.26v-.92a.27.27,0,1,1,.53,0v.92A.26.26,0,0,1,250.39,147Zm0-1.53a.27.27,0,0,1-.27-.27v-.92a.27.27,0,0,1,.53,0v.92A.27.27,0,0,1,250.39,145.46Zm0-1.54a.26.26,0,0,1-.27-.26v-.92a.27.27,0,0,1,.53,0v.92A.26.26,0,0,1,250.39,143.92Zm0-1.53a.27.27,0,0,1-.27-.26v-.92a.27.27,0,1,1,.53,0v.92A.26.26,0,0,1,250.39,142.39Zm0-1.53a.27.27,0,0,1-.27-.26v-.92a.27.27,0,1,1,.53,0v.92A.26.26,0,0,1,250.39,140.86Zm0-1.53a.27.27,0,0,1-.27-.27v-.92a.27.27,0,0,1,.53,0v.92A.27.27,0,0,1,250.39,139.33Zm0-1.53a.27.27,0,0,1-.27-.27v-.92a.27.27,0,0,1,.53,0v.92A.27.27,0,0,1,250.39,137.8Zm0-1.54a.27.27,0,0,1-.27-.26v-.92a.27.27,0,1,1,.53,0V136A.26.26,0,0,1,250.39,136.26Zm0-1.53a.27.27,0,0,1-.27-.26v-.92a.27.27,0,1,1,.53,0v.92A.26.26,0,0,1,250.39,134.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.76,71.36l1.57.9-.05.3-.52-.22.54,2.6,1.1-1.63-.5-.39,0-.3,1.32.76-.05.3-.53-.21-1.31,1.91c-.09.55-.16,1.1-.24,1.65l.6.44,0,.29-1.69-1,.05-.29.57.25.25-1.67L237.19,72l-.48-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,126.36a.4.4,0,0,0,.18.34c.2.12.5,0,.77-.31l.19.31c-.31.43-.8.82-1.32.51a.9.9,0,0,1-.44-.8,3.07,3.07,0,0,1,.05-.66,1.23,1.23,0,0,1-1.45.4,1.89,1.89,0,0,1-.71-1.73c0-1.74,1.32-3.15,2.38-2.54a1.17,1.17,0,0,1,.39.38l.29-1.74-.79-.53,0-.28,1.35.25.09.14-.95,5.7A4,4,0,0,0,273,126.36Zm-1.63-.71c.28.17.62.09,1.15-.4l.37-2.29a1.4,1.4,0,0,0-.47-.53.78.78,0,0,0-1,.11,2.52,2.52,0,0,0-.59,1.83A1.42,1.42,0,0,0,271.36,125.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.65,184.17l1.43.82-.05.3-.54-.22-1.29,1.31.78,2.86.58.42-.05.29-1.6-.92,0-.29.48.21-.61-2.24-1.1,1.22.56.43,0,.29-1.44-.83,0-.3.53.22,1.35-1.4-.75-2.73-.47-.36,0-.29,1.58.91-.06.29-.54-.23.57,2.08,1-1.13-.55-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84,90.5a1.79,1.79,0,0,1,.57.65l0,0a1.57,1.57,0,0,0,.63-.32,2,2,0,0,0,.37-.34c-.05-1.12-.14-1.81-.26-3.12s-.14-1.4-.27-1.47-.22,0-.47.34l-.16-.24c.28-.63.6-.76.89-.59s.41.43.5,1.52.13,2.11.16,3a8.74,8.74,0,0,0,1-2.38c.23-.94.33-1.07.53-1a.55.55,0,0,1,.26.47,1.34,1.34,0,0,1-.17.65c-.15.32-.3.62-.57,1.1a16.72,16.72,0,0,1-.93,1.56,4.65,4.65,0,0,1-.66.8c-.46.39-.87.56-1.28.33a1,1,0,0,1-.49-.83C230.5,90.45,230.65,90.38,230.84,90.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.59,94.14l.6-.41c.71-.48.91-.69.91-1.1a1,1,0,0,0-.48-.91.44.44,0,0,0-.31-.08l0,.32c0,.31-.1.34-.21.28a.39.39,0,0,1-.16-.29c.09-.56.36-.66.79-.41a1.42,1.42,0,0,1,.72,1.25c0,.62-.4.74-1.07,1.15l-.47.3,1.27.73-.07.38-1.54-.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,181.08c.15.09.24.2.36.54l.08.24a.38.38,0,0,0,.13-.1,6.1,6.1,0,0,0,.9-1l-.29-1.51c-.09-.43-.14-.58-.28-.66s-.29-.07-.53.33l-.16-.25c.26-.62.58-.77.88-.6s.41.45.54,1.12l.21,1.16a6.48,6.48,0,0,1,.76-1,.4.4,0,0,1,.57-.09,1.08,1.08,0,0,1,.47.76c0,.26-.13.37-.29.29a1,1,0,0,1-.38-.55l0-.09s-.06.05-.1.08a6.75,6.75,0,0,0-.9,1l.24,1.32c.11.58.2.74.4.85s.42,0,.67-.28l.18.28c-.34.46-.75.7-1.12.49-.21-.12-.37-.34-.48-.95l-.26-1.31a5.67,5.67,0,0,1-.8,1,.34.34,0,0,1-.48,0,1.26,1.26,0,0,1-.58-1A.19.19,0,0,1,297,181.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.57,186.79l.6-.41c.71-.49.9-.69.9-1.1a1,1,0,0,0-.47-.91.45.45,0,0,0-.32-.08l0,.32c0,.31-.09.34-.21.28a.42.42,0,0,1-.16-.3c.1-.55.37-.65.8-.4a1.42,1.42,0,0,1,.72,1.25c0,.61-.4.74-1.07,1.15l-.47.29,1.27.74-.07.38-1.55-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.21,152.35c.15.08.24.19.36.54l.08.23a.38.38,0,0,0,.13-.09,5.11,5.11,0,0,0,.9-1l-.29-1.5c-.08-.43-.13-.58-.28-.67s-.29-.07-.53.34l-.16-.26c.26-.61.58-.76.88-.59s.41.44.54,1.11l.21,1.16a9.05,9.05,0,0,1,.76-1,.41.41,0,0,1,.58-.09,1.12,1.12,0,0,1,.46.77c0,.26-.13.37-.28.28a.91.91,0,0,1-.39-.54l0-.1s-.06.06-.1.09a6.67,6.67,0,0,0-.9,1l.24,1.33c.11.57.21.73.4.85s.42,0,.67-.29l.18.28c-.34.47-.75.71-1.12.49-.21-.12-.37-.34-.48-.95l-.26-1.3a6.6,6.6,0,0,1-.79,1.05.36.36,0,0,1-.49,0,1.26,1.26,0,0,1-.58-1C247,152.31,247.1,152.28,247.21,152.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,155.62l0,.08-.13.7-.24,1.45c-.05.27-.09.54-.13.8l.6.43,0,.17-1.48-.85,0-.17.57.25.44-2.61-.57-.26,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.57,148.05a2,2,0,0,1,.57.65l0,0a1.57,1.57,0,0,0,.63-.32,2.92,2.92,0,0,0,.37-.34c-.06-1.12-.14-1.81-.26-3.12s-.15-1.4-.27-1.47-.22,0-.47.35l-.16-.25c.28-.63.59-.76.89-.59s.41.43.49,1.52.14,2.11.16,3a8.74,8.74,0,0,0,1-2.38c.23-.94.34-1.07.54-1a.54.54,0,0,1,.25.47,1.24,1.24,0,0,1-.17.65c-.15.32-.29.62-.56,1.1a17,17,0,0,1-.94,1.56,3.94,3.94,0,0,1-.66.8c-.46.4-.87.56-1.27.33a1,1,0,0,1-.5-.83C303.23,148,303.37,147.93,303.57,148.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.32,151.69l.6-.41c.71-.48.9-.69.9-1.1a1,1,0,0,0-.47-.91.45.45,0,0,0-.32-.08l0,.32c0,.31-.1.34-.21.28a.42.42,0,0,1-.16-.29c.1-.56.36-.66.8-.41a1.43,1.43,0,0,1,.71,1.25c0,.62-.4.74-1.06,1.15l-.47.3,1.27.73-.07.38-1.55-.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,147.59l3,1.75v.6l-3-1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.56,153.24a2.1,2.1,0,0,1,.57.65l0,0a1.68,1.68,0,0,0,.63-.31,4,4,0,0,0,.37-.35c-.06-1.12-.14-1.81-.26-3.12s-.15-1.4-.27-1.47-.22,0-.47.35l-.16-.25c.28-.63.59-.76.89-.59s.41.43.49,1.52.14,2.12.16,3a8.74,8.74,0,0,0,1-2.38c.23-.94.34-1.07.54-1a.54.54,0,0,1,.25.47,1.24,1.24,0,0,1-.17.65c-.15.32-.29.62-.56,1.1a17,17,0,0,1-.94,1.56,3.94,3.94,0,0,1-.66.8c-.46.4-.86.56-1.27.33a1,1,0,0,1-.5-.83C312.22,153.19,312.36,153.12,312.56,153.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.67,154.45l0,.08-.13.7-.24,1.45c0,.26-.09.53-.13.8l.6.43,0,.17-1.48-.85,0-.18.57.26.44-2.61-.57-.26,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.32,174c.15.08.24.19.36.54l.08.23a.38.38,0,0,0,.13-.09,5.11,5.11,0,0,0,.9-1l-.29-1.5c-.08-.43-.13-.58-.28-.66s-.29-.08-.52.33l-.17-.25c.26-.62.59-.77.88-.6s.41.44.54,1.11l.22,1.16a8.09,8.09,0,0,1,.75-1,.42.42,0,0,1,.58-.09,1.17,1.17,0,0,1,.47.77c0,.26-.14.37-.29.28a1,1,0,0,1-.39-.54l0-.1-.1.09a6.29,6.29,0,0,0-.9,1l.25,1.32c.1.57.2.73.39.85s.43,0,.68-.29l.17.28c-.33.47-.75.71-1.12.49-.21-.12-.36-.34-.48-1l-.26-1.3a6.6,6.6,0,0,1-.79,1,.36.36,0,0,1-.49,0,1.26,1.26,0,0,1-.58-1C267.06,174,267.21,173.94,267.32,174Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,179.71l.6-.41c.71-.48.91-.68.91-1.1a1,1,0,0,0-.48-.91.44.44,0,0,0-.32-.07l0,.31c0,.32-.1.35-.21.29a.39.39,0,0,1-.16-.3c.09-.55.36-.66.8-.4a1.41,1.41,0,0,1,.71,1.25c0,.61-.4.73-1.07,1.14l-.47.3,1.27.73-.07.39-1.54-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,175.62l3,1.74v.6l-3-1.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,179.37c.14.09.23.2.35.55l.08.23a.38.38,0,0,0,.13-.09,6.17,6.17,0,0,0,.91-1l-.3-1.5c-.08-.44-.13-.58-.28-.67s-.28-.07-.52.33l-.16-.25c.26-.62.58-.77.87-.6s.41.45.54,1.12l.22,1.16a8.09,8.09,0,0,1,.75-1,.41.41,0,0,1,.58-.09,1.12,1.12,0,0,1,.47.76c0,.26-.14.37-.29.29a.94.94,0,0,1-.38-.54l0-.1s-.06.05-.1.08a8,8,0,0,0-.9,1l.25,1.33c.1.57.2.73.4.84s.42,0,.67-.28l.17.28c-.33.46-.75.7-1.12.49-.21-.12-.36-.34-.48-.95l-.26-1.31a6.17,6.17,0,0,1-.79,1.05.35.35,0,0,1-.49,0,1.22,1.22,0,0,1-.57-1C276.35,179.33,276.5,179.31,276.62,179.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,182.64l.05.08-.14.7-.24,1.45c0,.27-.09.54-.13.8l.61.44,0,.17-1.47-.86,0-.17.57.25.43-2.6-.56-.27,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,120.61l1.15.67a2.13,2.13,0,0,1,1.14,1.84c0,.91-.51,1.28-1.42.76l-.35-.2c-.06.42-.13.86-.18,1.29l.48.36,0,.25-1.36-.79,0-.25.43.18.3-1.91c.08-.53.15-1.07.22-1.61l-.46-.33Zm.86.82-.29,1.94v0l.3.17c.64.37,1,.07,1-.63a1.5,1.5,0,0,0-.75-1.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.34,128.46l.43-.29c.51-.35.65-.5.65-.8a.72.72,0,0,0-.34-.66.3.3,0,0,0-.23,0l0,.23c0,.22-.07.25-.15.2a.3.3,0,0,1-.12-.21c.07-.4.27-.47.58-.29a1,1,0,0,1,.51.9c0,.44-.28.53-.76.83l-.34.21.91.53,0,.27-1.11-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,126.31a2.48,2.48,0,0,1,1.65-2.67l.11.27a2.56,2.56,0,0,0-1.37,2.65,7.83,7.83,0,0,0,.54,2.75l-.17,0A7.36,7.36,0,0,1,305.1,126.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,127.76c.11.06.17.14.26.39l.06.17a.28.28,0,0,0,.09-.07,3.92,3.92,0,0,0,.65-.74l-.21-1.09c-.06-.31-.09-.42-.2-.48s-.21,0-.38.24l-.11-.18c.18-.45.41-.55.63-.43s.29.32.38.8l.16.84a5.78,5.78,0,0,1,.55-.71.28.28,0,0,1,.41-.06.79.79,0,0,1,.34.55c0,.19-.1.27-.21.2a.68.68,0,0,1-.28-.39l0-.07-.07.06a5.06,5.06,0,0,0-.65.73l.18,1c.07.41.14.52.28.61s.31,0,.49-.21l.13.2c-.25.34-.54.51-.81.36s-.26-.25-.35-.69l-.19-.94a3.73,3.73,0,0,1-.57.76.26.26,0,0,1-.35,0,.92.92,0,0,1-.41-.72C306.47,127.73,306.58,127.71,306.66,127.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25,131.88l.43-.3c.51-.35.65-.5.65-.8a.69.69,0,0,0-.34-.65.36.36,0,0,0-.23-.06l0,.23c0,.23-.07.25-.15.2a.25.25,0,0,1-.11-.21c.07-.4.26-.47.57-.29a1,1,0,0,1,.51.9c0,.44-.28.53-.76.83l-.34.21.91.53-.05.28-1.11-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,128.92l2.18,1.26v.43l-2.18-1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,131.63c.11.06.17.14.26.39l.05.17.1-.07a4.38,4.38,0,0,0,.65-.75l-.21-1.08c-.06-.31-.1-.42-.2-.48s-.21-.06-.38.24l-.12-.18c.19-.45.42-.56.63-.43s.3.31.39.8l.16.84a4.62,4.62,0,0,1,.54-.71.3.3,0,0,1,.42-.07.83.83,0,0,1,.33.55c0,.19-.09.27-.2.21a.72.72,0,0,1-.28-.39l0-.07s-.05,0-.07.06a4.58,4.58,0,0,0-.65.73l.17,1c.08.42.15.53.29.61s.31,0,.49-.2l.12.2c-.24.34-.54.51-.8.35s-.27-.24-.35-.68l-.19-.94a4.52,4.52,0,0,1-.57.76.25.25,0,0,1-.35,0,.9.9,0,0,1-.42-.72A.14.14,0,0,1,313.36,131.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.92,134l0,.06-.09.51-.18,1-.09.58.44.31,0,.12-1.06-.61,0-.12.41.18.31-1.88-.4-.19,0-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,133.27a2.48,2.48,0,0,1-1.65,2.68l-.12-.28a2.55,2.55,0,0,0,1.38-2.64,7.86,7.86,0,0,0-.55-2.75l.17-.05A7.42,7.42,0,0,1,318.94,133.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,113.62l1.15.66a2.15,2.15,0,0,1,1.15,1.85c0,.91-.51,1.28-1.42.75l-.35-.2c-.07.43-.13.87-.18,1.3l.48.36,0,.24-1.36-.78,0-.25.43.18.3-1.91c.08-.53.15-1.07.22-1.61l-.46-.34Zm.87.82-.29,1.93v0l.3.17c.64.37,1,.06,1-.64a1.48,1.48,0,0,0-.75-1.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,119.71l0,.06-.1.51-.17,1c0,.19-.07.39-.1.58l.44.31,0,.12-1.07-.61,0-.13.41.19.32-1.88-.41-.19,0-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.83,119.32a2.49,2.49,0,0,1,1.65-2.68l.12.28a2.56,2.56,0,0,0-1.37,2.65,7.83,7.83,0,0,0,.54,2.75l-.17,0A7.38,7.38,0,0,1,245.83,119.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4,120.77c.11.06.17.14.26.39l.06.17.09-.07a4,4,0,0,0,.65-.75l-.21-1.08c-.06-.31-.1-.42-.2-.48s-.21,0-.38.24l-.12-.18c.19-.45.42-.56.63-.43s.3.32.39.8l.16.84a5.39,5.39,0,0,1,.54-.71.3.3,0,0,1,.42-.07.79.79,0,0,1,.33.56c0,.18-.09.26-.2.2a.72.72,0,0,1-.28-.39l0-.07-.07.06a4.58,4.58,0,0,0-.65.73l.18,1c.07.42.14.53.28.61s.31,0,.49-.2l.12.2c-.24.34-.54.51-.8.35s-.27-.24-.35-.68l-.19-.94a4,4,0,0,1-.57.76c-.11.11-.21.1-.35,0a.89.89,0,0,1-.41-.71C247.21,120.74,247.32,120.72,247.4,120.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,124.88l.43-.29c.51-.35.65-.5.65-.8a.72.72,0,0,0-.34-.66.35.35,0,0,0-.23,0l0,.23c0,.22-.07.25-.15.2a.3.3,0,0,1-.12-.21c.07-.4.26-.47.58-.29a1,1,0,0,1,.51.9c0,.44-.29.53-.76.83l-.34.21.91.53-.05.27-1.11-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.61,121.93l2.18,1.25v.44l-2.18-1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,124.64c.11.06.17.14.26.39l0,.16a.21.21,0,0,0,.1-.06,4.38,4.38,0,0,0,.65-.75l-.21-1.09c-.06-.31-.1-.41-.2-.48s-.21,0-.38.24l-.12-.18c.19-.44.42-.55.63-.43s.3.32.39.81l.16.83a5.94,5.94,0,0,1,.54-.71.3.3,0,0,1,.42-.06.83.83,0,0,1,.33.55c0,.19-.09.27-.2.21a.63.63,0,0,1-.28-.39l0-.07s0,0-.07.06a5,5,0,0,0-.65.72l.17,1c.08.41.15.53.29.61s.3,0,.49-.2l.12.2c-.24.33-.54.51-.81.35s-.26-.24-.34-.68l-.19-.95a4.26,4.26,0,0,1-.57.77.25.25,0,0,1-.35,0,.89.89,0,0,1-.42-.72A.14.14,0,0,1,254.1,124.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,127l0,.06-.09.5-.18,1-.09.58.44.31,0,.12-1.06-.61,0-.13.41.19.31-1.88-.4-.2,0-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,126.28A2.49,2.49,0,0,1,258,129l-.12-.28a2.55,2.55,0,0,0,1.37-2.65,7.87,7.87,0,0,0-.54-2.75l.17,0A7.38,7.38,0,0,1,259.68,126.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84,121.3a1.88,1.88,0,0,1,.57.65l0,0a1.57,1.57,0,0,0,.63-.32,2,2,0,0,0,.37-.35c-.05-1.12-.14-1.8-.26-3.11s-.14-1.4-.27-1.48-.22,0-.47.35l-.16-.24c.28-.63.6-.77.89-.6s.41.43.5,1.53.13,2.11.16,3a8.68,8.68,0,0,0,1-2.37c.23-.94.33-1.08.53-1a.53.53,0,0,1,.26.46,1.4,1.4,0,0,1-.17.66c-.15.31-.3.61-.57,1.09a15.58,15.58,0,0,1-.93,1.57,4.26,4.26,0,0,1-.66.79c-.46.4-.87.56-1.28.33a1,1,0,0,1-.49-.83C230.5,121.25,230.65,121.19,230.84,121.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,122.51l.05.08-.14.7-.24,1.45c-.05.27-.09.54-.13.8l.61.43,0,.17-1.47-.85,0-.17.57.25.43-2.61-.56-.26,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,140.23l1.35.78,0,.28-.51-.21L333,142.32l.74,2.69.54.41-.05.27-1.51-.88.05-.27.46.2-.58-2.11-1,1.15.53.4,0,.27-1.37-.78,0-.28.51.21,1.27-1.32-.71-2.58-.45-.34,0-.28,1.49.86-.05.28-.52-.22.54,2,1-1.07-.51-.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3,149.38l1.3.75v.48l-1.3-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.21,152.07a7.8,7.8,0,0,1,.13-1.1l.47-2.9-.55-.37,0-.2,1,.18.07.1-.43,2.53A.87.87,0,0,1,348,150a1.3,1.3,0,0,1,.51,1.21c0,1.26-.92,2.28-1.83,1.76A1.06,1.06,0,0,1,346.21,152.07Zm.71.56a.59.59,0,0,0,.66,0,1.71,1.71,0,0,0,.5-1.35c0-.48-.13-.79-.34-.91s-.55,0-.9.28l-.09.46a4.92,4.92,0,0,0-.11,1A.63.63,0,0,0,346.92,152.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.21,153.22l-1.08-.62v-.4l1.08.63v-1.54l.32.18V153l1.08.62v.4l-1.08-.62V155l-.32-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,159.9a7.68,7.68,0,0,1,.13-1.09l.47-2.91-.55-.37,0-.2,1,.19.07.09-.43,2.53a.87.87,0,0,1,1.1-.31,1.3,1.3,0,0,1,.51,1.21c0,1.26-.92,2.27-1.83,1.75A1.05,1.05,0,0,1,359.78,159.9Zm.71.56a.57.57,0,0,0,.66,0,1.69,1.69,0,0,0,.5-1.35c0-.47-.13-.79-.34-.91s-.55,0-.9.28l-.09.47a4.85,4.85,0,0,0-.11,1A.61.61,0,0,0,360.49,160.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.24,159.08l.48-.32c.57-.39.72-.55.72-.88a.79.79,0,0,0-.38-.73.32.32,0,0,0-.25-.06l0,.25c0,.25-.08.28-.17.23a.34.34,0,0,1-.13-.24c.08-.44.29-.52.64-.32a1.14,1.14,0,0,1,.57,1c0,.49-.32.59-.85.91l-.38.24,1,.59-.05.3-1.24-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35,161.53l1.29.75v.47l-1.29-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,165.08l-.24,1.4-.38-.23.23-1.4-1.61-.93.06-.34,2.18-1.85.29.17-.46,2.76.61.36-.07.41Zm-.31-.64.36-2.14-1.66,1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.67,167.54a2.38,2.38,0,0,1,0-.39c-.33.31-.68.44-1,.26a1.32,1.32,0,0,1-.53-1.18c0-1.3,1-2.26,1.72-1.85a.91.91,0,0,1,.32.39l.26-.13.1.13-.45,2.37a2.57,2.57,0,0,0-.05.39.29.29,0,0,0,.14.24c.14.08.35,0,.55-.22l.13.22c-.22.31-.57.58-1,.36A.67.67,0,0,1,372.67,167.54ZM372,167c.19.11.43.07.8-.25l.3-1.69a1.37,1.37,0,0,0-.34-.34.56.56,0,0,0-.62.08,1.74,1.74,0,0,0-.48,1.34A1,1,0,0,0,372,167Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.16,167.43c0-1.26.73-1.91,1.43-1.5a1.25,1.25,0,0,1,.6.89c0,.17-.12.19-.23.13a1.24,1.24,0,0,1-.33-.46l-.17-.35c-.48-.06-.89.53-.89,1.45a1.46,1.46,0,0,0,.62,1.32.54.54,0,0,0,.69-.15l.13.21a.73.73,0,0,1-1,.34A2.09,2.09,0,0,1,374.16,167.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.68,169.75l.82-.56c1-.66,1.24-.94,1.24-1.51a1.36,1.36,0,0,0-.65-1.24.58.58,0,0,0-.43-.1l0,.43c0,.43-.14.47-.29.38a.51.51,0,0,1-.22-.4c.13-.76.49-.9,1.09-.55a1.93,1.93,0,0,1,1,1.71c0,.84-.55,1-1.46,1.57l-.65.41,1.74,1-.09.52-2.12-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,172.38c0-.15,0-.26,0-.39-.32.31-.67.44-1,.26a1.32,1.32,0,0,1-.53-1.18c0-1.3,1-2.26,1.73-1.85a.91.91,0,0,1,.32.39l.25-.13.11.13-.45,2.37a2.57,2.57,0,0,0-.05.39.28.28,0,0,0,.13.24c.14.08.35,0,.55-.22l.13.22c-.21.31-.57.58-.94.36A.67.67,0,0,1,363,172.38Zm-.72-.5c.2.11.43.07.8-.25l.31-1.69a1.39,1.39,0,0,0-.35-.34.54.54,0,0,0-.61.08,1.71,1.71,0,0,0-.48,1.34A1,1,0,0,0,362.25,171.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,145v-.4l2.49,1.44v.39Zm0,1.49v-.4l2.49,1.43v.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,163a.2.2,0,0,1-.13,0l-17.84-10.29-3.37,5.48a.26.26,0,0,1-.26.11.23.23,0,0,1-.2-.18l-1.36-5.88a.25.25,0,0,1,.49-.11l1.22,5.28,3.19-5.17a.24.24,0,0,1,.33-.09l18.05,10.42a.25.25,0,0,1-.12.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,173.36a.28.28,0,0,1-.13,0L343.14,153.8a.25.25,0,0,1-.09-.34.26.26,0,0,1,.34-.1l33.83,19.54a.25.25,0,0,1,.09.34A.24.24,0,0,1,377.1,173.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.7 157.21 349.98 155.64 350.14 155.37 352.86 156.94 352.7 157.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.45,183.76l1.92,1.11a4.25,4.25,0,0,1,2,3.72c0,2.48-1.34,2.91-2.77,2.09l-1.92-1.11,0-.35.61.25.4-2.66c.11-.74.22-1.48.32-2.23l-.64-.47Zm.47,6.11.75.43c1.34.78,2-.54,2-2.09a3.4,3.4,0,0,0-1.6-3.07l-.43-.24-.41,2.68C235.13,188.34,235,189.1,234.92,189.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,202.38c0-1.94.77-3.24,2.3-3.72l.16.39c-1.28.62-1.91,1.7-1.91,3.68a10.79,10.79,0,0,0,.76,3.82l-.24.06A10.32,10.32,0,0,1,258.68,202.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.86,204.4c.15.09.24.2.36.54l.08.24a.38.38,0,0,0,.13-.09,6.17,6.17,0,0,0,.91-1l-.29-1.51c-.09-.44-.14-.59-.29-.67s-.28-.07-.52.33l-.16-.25c.26-.62.58-.77.87-.6s.42.45.55,1.12l.21,1.16a9.05,9.05,0,0,1,.76-1,.41.41,0,0,1,.58-.09,1.17,1.17,0,0,1,.47.77c0,.26-.13.37-.29.28a1,1,0,0,1-.39-.54l0-.1a.87.87,0,0,1-.1.08,7.37,7.37,0,0,0-.9,1l.24,1.33c.11.57.21.73.4.85s.42,0,.68-.29l.17.28c-.33.47-.75.71-1.12.49-.21-.12-.37-.34-.49-.95l-.26-1.31a5.7,5.7,0,0,1-.79,1.06.36.36,0,0,1-.49,0,1.26,1.26,0,0,1-.58-1A.19.19,0,0,1,260.86,204.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,210.13l.61-.41c.72-.49.91-.7.91-1.11a1,1,0,0,0-.48-.92.44.44,0,0,0-.32-.07l0,.32c0,.31-.09.34-.2.28a.4.4,0,0,1-.17-.3c.1-.55.37-.66.81-.4a1.42,1.42,0,0,1,.71,1.25c0,.62-.4.75-1.07,1.16l-.47.3L266,211l-.06.39-1.56-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.37,207l1.63.94v.59l-1.63-.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,210.87a.85.85,0,0,1,.35.55l.08.23a.55.55,0,0,0,.14-.09,6.18,6.18,0,0,0,.9-1l-.29-1.51c-.09-.43-.14-.58-.28-.67s-.29-.07-.53.33l-.16-.25c.26-.62.58-.76.88-.6s.41.45.54,1.12l.21,1.17a8.45,8.45,0,0,1,.76-1,.41.41,0,0,1,.58-.09,1.17,1.17,0,0,1,.47.77c0,.26-.13.37-.29.28a.9.9,0,0,1-.38-.54l-.05-.1-.1.09a7.36,7.36,0,0,0-.9,1l.25,1.33c.1.57.2.74.4.85s.42,0,.67-.29l.18.28c-.34.47-.76.71-1.13.5-.21-.12-.36-.35-.48-1l-.26-1.31a5.79,5.79,0,0,1-.8,1.06.36.36,0,0,1-.49,0,1.26,1.26,0,0,1-.58-1C271.81,210.83,272,210.81,272.08,210.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,214.16l0,.08-.14.7-.24,1.46c0,.26-.08.54-.13.8l.61.44,0,.17-1.49-.86,0-.17.58.25.43-2.62-.57-.27,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.85,213.17c0,1.94-.77,3.25-2.3,3.72l-.16-.38c1.28-.63,1.91-1.71,1.91-3.68a10.8,10.8,0,0,0-.76-3.83l.24-.06A10.32,10.32,0,0,1,279.85,213.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.4,213.09l.61-.41c.72-.49.91-.69.91-1.11a1,1,0,0,0-.48-.91.45.45,0,0,0-.32-.08l0,.32c0,.31-.09.35-.21.28a.42.42,0,0,1-.16-.29c.1-.56.37-.66.8-.41a1.43,1.43,0,0,1,.72,1.26c0,.62-.4.74-1.07,1.15l-.47.3,1.27.74-.06.38-1.56-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,216.39l-1.36-.79v-.5l1.36.79V214l.4.24v1.93l1.36.79v.49l-1.36-.78v2l-.4-.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.18,220c0-1.94.76-3.25,2.3-3.72l.16.38c-1.28.63-1.91,1.71-1.91,3.69a11,11,0,0,0,.75,3.82l-.23.06A10.17,10.17,0,0,1,289.18,220Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,224a1.88,1.88,0,0,1,.57.65l0,0a1.64,1.64,0,0,0,.63-.32,2.37,2.37,0,0,0,.37-.34c-.05-1.13-.14-1.82-.25-3.13s-.15-1.4-.28-1.48-.22,0-.47.35l-.16-.24c.28-.64.6-.77.89-.6s.42.43.5,1.53.13,2.12.16,3a8.74,8.74,0,0,0,1-2.38c.24-.94.34-1.08.54-1a.54.54,0,0,1,.26.46,1.27,1.27,0,0,1-.18.66c-.15.32-.29.62-.56,1.1a18,18,0,0,1-.94,1.57,4.23,4.23,0,0,1-.66.8c-.47.4-.87.56-1.28.33a1,1,0,0,1-.5-.83C290.7,223.94,290.84,223.87,291,224Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.8,227.64l.61-.41c.71-.49.91-.69.91-1.11a1,1,0,0,0-.48-.91.45.45,0,0,0-.32-.08l0,.32c0,.32-.1.35-.21.28a.4.4,0,0,1-.16-.29c.1-.56.36-.66.8-.41a1.43,1.43,0,0,1,.72,1.26c0,.62-.4.74-1.07,1.15l-.48.3,1.28.74-.07.38-1.55-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,224.48l1.62.94v.6l-1.62-.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,230.28a2,2,0,0,1,.57.66l0,0a1.64,1.64,0,0,0,.63-.32,3,3,0,0,0,.37-.34c-.05-1.13-.14-1.82-.26-3.13s-.14-1.4-.27-1.48-.22,0-.47.35l-.16-.25c.28-.63.6-.76.89-.59s.41.43.5,1.53.13,2.12.16,3a8.74,8.74,0,0,0,1-2.38c.23-.94.34-1.08.54-1a.54.54,0,0,1,.26.46,1.27,1.27,0,0,1-.18.66c-.15.32-.29.62-.56,1.1a18,18,0,0,1-.94,1.57,4.23,4.23,0,0,1-.66.8c-.47.39-.87.56-1.28.33a1,1,0,0,1-.5-.83C301.61,230.23,301.75,230.17,302,230.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.08,231.5l0,.08-.13.7-.24,1.46c-.05.27-.09.54-.14.8l.62.44,0,.17-1.48-.86,0-.17.57.25.44-2.62-.57-.26,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,230.51c0,1.94-.77,3.25-2.3,3.72l-.16-.39c1.28-.62,1.91-1.7,1.91-3.67a10.8,10.8,0,0,0-.76-3.83l.24-.06A10.32,10.32,0,0,1,309.88,230.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.44,230.43l.6-.41c.72-.49.91-.69.91-1.11a1,1,0,0,0-.47-.91.47.47,0,0,0-.32-.08l0,.32c0,.31-.1.35-.21.28a.39.39,0,0,1-.16-.29c.09-.56.36-.66.8-.41a1.43,1.43,0,0,1,.72,1.26c0,.62-.41.74-1.07,1.15l-.48.3,1.28.74-.07.38-1.55-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,191.16v-.49l3.12,1.8V193Zm0,1.88v-.5l3.12,1.8v.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.51,226.87a.28.28,0,0,1-.15,0l-57-32.91-4.25,6.89a.33.33,0,0,1-.32.15.31.31,0,0,1-.25-.24l-1.71-7.38a.32.32,0,0,1,.23-.38.31.31,0,0,1,.38.24l1.54,6.63,4-6.5a.33.33,0,0,1,.43-.11l57.26,33.06a.32.32,0,0,1,.12.43A.33.33,0,0,1,314.51,226.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.24,169.58c0-.14,0-.25,0-.38-.32.31-.67.44-1,.26a1.32,1.32,0,0,1-.54-1.18c0-1.3,1-2.26,1.73-1.85a.91.91,0,0,1,.32.39l.26-.13.1.12-.45,2.38a2.57,2.57,0,0,0,0,.39.28.28,0,0,0,.14.24c.14.08.35,0,.54-.22l.14.22c-.22.31-.57.58-1,.36A.67.67,0,0,1,332.24,169.58Zm-.71-.49c.19.11.43.07.8-.25l.3-1.69a1.36,1.36,0,0,0-.34-.34.56.56,0,0,0-.62.08,1.69,1.69,0,0,0-.48,1.34A1,1,0,0,0,331.53,169.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,173.28l0-.05.28-1.59-.33-.21,0-.12.55.1,0,.07-.06.41a.64.64,0,0,1,.68-.1.44.44,0,0,1,.21.42,1.59,1.59,0,0,1-.06.39l-.14.72a1,1,0,0,0,0,.23.14.14,0,0,0,.06.13c.08,0,.2,0,.32-.13l.08.13a.43.43,0,0,1-.57.2.31.31,0,0,1-.16-.28,1.68,1.68,0,0,1,.05-.32l.14-.68a2,2,0,0,0,.06-.35.28.28,0,0,0-.12-.27c-.12-.07-.3,0-.54.08l-.09.47c-.05.28-.09.56-.13.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,176.32l.82-.56c1-.67,1.24-.95,1.24-1.51a1.36,1.36,0,0,0-.64-1.25.64.64,0,0,0-.44-.1l0,.43c0,.43-.13.48-.28.39a.58.58,0,0,1-.23-.41c.14-.75.5-.89,1.1-.55a2,2,0,0,1,1,1.71c0,.85-.55,1-1.46,1.57l-.65.41,1.74,1-.09.53-2.12-1.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,176l0-.06.28-1.58-.32-.21V174l.56.1,0,.06-.07.41a.66.66,0,0,1,.68-.1.44.44,0,0,1,.21.42,1.75,1.75,0,0,1,0,.4l-.15.72a1.85,1.85,0,0,0,0,.23.18.18,0,0,0,.06.13c.08,0,.21,0,.33-.13l.07.13a.42.42,0,0,1-.56.2.33.33,0,0,1-.16-.28,1.68,1.68,0,0,1,.05-.32l.14-.69a3.11,3.11,0,0,0,.05-.34c0-.16,0-.23-.11-.27a.6.6,0,0,0-.55.07l-.08.48c0,.27-.09.55-.14.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.72,178.33l-1.09-.63v-.39l1.09.63v-1.55l.32.19v1.54l1.08.62v.4l-1.08-.63v1.57l-.32-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.88,181.93l.82-.56c1-.66,1.24-.94,1.24-1.51a1.36,1.36,0,0,0-.65-1.24.6.6,0,0,0-.44-.11l0,.44c0,.42-.13.47-.28.38a.52.52,0,0,1-.22-.4c.13-.76.49-.9,1.09-.55a1.93,1.93,0,0,1,1,1.71c0,.84-.55,1-1.46,1.57l-.65.41,1.74,1-.09.52-2.12-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.17,184.55a2.3,2.3,0,0,1,0-.38c-.32.31-.68.44-1,.26a1.32,1.32,0,0,1-.53-1.18c0-1.3,1-2.27,1.73-1.85a.85.85,0,0,1,.32.39l.25-.13.1.12-.44,2.37a1.85,1.85,0,0,0-.05.4.29.29,0,0,0,.13.24c.14.08.35,0,.55-.22l.13.22c-.21.3-.57.58-.94.36A.67.67,0,0,1,358.17,184.55Zm-.72-.49c.2.11.43.07.8-.26l.3-1.68a1.1,1.1,0,0,0-.34-.34.52.52,0,0,0-.61.08,1.68,1.68,0,0,0-.48,1.33A1,1,0,0,0,357.45,184.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.63,188.25l0-.06.27-1.58-.32-.21v-.12l.56.1,0,.07-.07.4a.64.64,0,0,1,.68-.09.43.43,0,0,1,.21.42,1.67,1.67,0,0,1-.05.39l-.15.72a2.23,2.23,0,0,0,0,.23.16.16,0,0,0,.06.13c.08,0,.21,0,.33-.13l.07.13a.42.42,0,0,1-.56.2.33.33,0,0,1-.16-.28,1.68,1.68,0,0,1,0-.32l.14-.68c0-.14.05-.27.05-.35s0-.23-.11-.27a.56.56,0,0,0-.54.08l-.09.47c-.05.28-.09.55-.13.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.13,188.42l.75.44v.28l-.75-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,188.45l0,.07-.11.56-.19,1.15c0,.22-.07.43-.11.64l.49.35,0,.14-1.18-.69,0-.13.45.2.35-2.08-.45-.22,0-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,170v-.4l2.49,1.44v.39Zm0,1.49v-.4l2.49,1.44V173Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37,191.18c.47-3.24,1.7-3.65,2.67-3.09a1.83,1.83,0,0,1,.88,1.39c-.1.38-.33.54-.65.36a1.67,1.67,0,0,1-.64-.9l-.16-.47c-.65.19-1,1.13-1.23,2.64-.06.36-.18,1.1-.42,3.6-.12,1.4-.32,2.68-.53,4-.49,3.26-1.77,3.61-2.67,3.09a1.77,1.77,0,0,1-.87-1.39c.1-.37.33-.55.66-.36a1.53,1.53,0,0,1,.62.9l.16.46c.69-.28,1.06-1.53,1.24-2.62.23-1.4.4-2.85.55-4.36C334.2,192.11,334.32,191.48,334.37,191.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.49,195.61a1,1,0,0,1-.77-.11,2.11,2.11,0,0,1-.94-1.8c0-1,.57-1.35,1.25-1a2.47,2.47,0,0,1,1,2.2c0,1.61-.88,2.36-2.36,2l-.05-.31C343.62,196.78,344.25,196.44,344.49,195.61Zm-.59-.36a1,1,0,0,0,.64.13,3.62,3.62,0,0,0,.06-.69A1.88,1.88,0,0,0,344,193c-.42-.24-.76.13-.76.83A1.58,1.58,0,0,0,343.9,195.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.24,197.65c.12.07.19.16.29.43l.06.19.11-.07a5.37,5.37,0,0,0,.72-.83l-.24-1.2c-.07-.35-.1-.47-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.46-.61.7-.47s.33.35.43.88l.17.93a5.59,5.59,0,0,1,.61-.78.32.32,0,0,1,.46-.07.87.87,0,0,1,.37.61c0,.21-.11.29-.23.22s-.2-.16-.31-.43l0-.08-.08.07a6.12,6.12,0,0,0-.72.8l.2,1.06c.08.46.16.59.31.68s.34,0,.54-.23l.14.22c-.27.38-.6.57-.89.4s-.29-.28-.39-.76l-.21-1.05a4.79,4.79,0,0,1-.63.85.28.28,0,0,1-.39,0,1,1,0,0,1-.46-.79C345,197.62,345.15,197.6,345.24,197.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65,199.22l-1.08-.63v-.39l1.08.62v-1.54l.32.19V199l1.08.62v.4L351,199.4V201l-.32-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.81,202.82l.82-.56c1-.66,1.24-.94,1.24-1.51a1.34,1.34,0,0,0-.64-1.24.6.6,0,0,0-.44-.11l0,.43c0,.43-.13.48-.28.39a.56.56,0,0,1-.23-.4c.14-.76.5-.9,1.1-.56a2,2,0,0,1,1,1.72c0,.84-.55,1-1.46,1.57l-.65.4,1.74,1-.09.52-2.12-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52,214.6a.31.31,0,0,0,.12.24c.15.08.36,0,.55-.22l.14.21c-.22.31-.57.59-.94.37a.65.65,0,0,1-.32-.57,2.52,2.52,0,0,1,0-.47.88.88,0,0,1-1,.29,1.35,1.35,0,0,1-.5-1.23c0-1.24.93-2.24,1.69-1.81a.77.77,0,0,1,.27.27l.22-1.23-.57-.38,0-.2,1,.18.07.09-.68,4.06A2.51,2.51,0,0,0,365.52,214.6Zm-1.16-.51c.2.12.44.07.81-.28l.27-1.63a1,1,0,0,0-.34-.37.54.54,0,0,0-.67.07,1.8,1.8,0,0,0-.42,1.3C364,213.67,364.16,214,364.36,214.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.45,215c.12.07.19.16.29.43l.06.19.11-.07a4.88,4.88,0,0,0,.72-.83l-.24-1.2c-.06-.35-.1-.47-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.47-.61.7-.48s.33.36.43.89l.17.93a5.59,5.59,0,0,1,.61-.78.32.32,0,0,1,.46-.07.87.87,0,0,1,.37.61c0,.21-.11.29-.23.22s-.2-.16-.31-.43l0-.08-.08.07a5.54,5.54,0,0,0-.72.8l.2,1.06c.08.46.16.59.32.68s.33,0,.53-.23l.14.22c-.27.38-.6.57-.89.4s-.29-.28-.39-.76l-.21-1a4.56,4.56,0,0,1-.63.84.28.28,0,0,1-.39,0,1,1,0,0,1-.46-.79C366.24,215,366.36,215,366.45,215Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,204.91c.12.07.19.16.29.43l.06.19.1-.07a4.88,4.88,0,0,0,.72-.83l-.23-1.2c-.07-.35-.11-.46-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.46-.61.7-.47s.33.35.43.88l.17.93a5.7,5.7,0,0,1,.6-.78c.17-.16.28-.18.46-.07a.88.88,0,0,1,.38.61c0,.21-.11.29-.23.22s-.2-.16-.31-.43l0-.08-.08.07a5.62,5.62,0,0,0-.72.81l.19,1c.09.46.17.59.32.68s.34,0,.54-.23l.14.23c-.27.37-.6.56-.9.39s-.29-.28-.38-.76l-.21-1a4.67,4.67,0,0,1-.63.84.28.28,0,0,1-.39,0,1,1,0,0,1-.46-.79C339.79,204.88,339.91,204.86,340,204.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,204.51l.49-.33c.57-.39.72-.55.72-.88a.79.79,0,0,0-.38-.73.32.32,0,0,0-.25-.06l0,.25c0,.25-.07.28-.16.23a.34.34,0,0,1-.13-.24c.07-.44.29-.52.64-.32a1.14,1.14,0,0,1,.57,1c0,.49-.32.59-.85.91l-.38.24,1,.59-.05.3-1.24-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.53,207.13l-1.08-.63v-.39l1.08.62v-1.54l.32.18v1.54l1.08.63v.39l-1.08-.62v1.57l-.32-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,210.45c.12.07.19.16.28.44l.06.18a.26.26,0,0,0,.11-.07,4.53,4.53,0,0,0,.72-.83l-.23-1.2c-.07-.34-.11-.46-.23-.53s-.23-.06-.42.26l-.12-.2c.2-.49.46-.61.7-.47s.33.35.43.89l.17.92a6.43,6.43,0,0,1,.6-.78.33.33,0,0,1,.46-.07.9.9,0,0,1,.38.61c0,.21-.11.3-.23.23a.73.73,0,0,1-.31-.44l0-.07a.24.24,0,0,0-.08.06,5.08,5.08,0,0,0-.72.81l.19,1.05c.09.46.16.59.32.68s.34,0,.54-.23l.14.23c-.27.37-.6.56-.9.39s-.29-.27-.38-.76l-.21-1a5.19,5.19,0,0,1-.63.84.29.29,0,0,1-.39,0,1,1,0,0,1-.46-.8C349.39,210.42,349.51,210.4,349.6,210.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,212l-1.08-.62V211l1.08.63v-1.55l.32.19v1.54l1.08.62v.4l-1.08-.62v1.57l-.32-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,213.84c0-1.71,1-2.7,2.53-1.85v.24a1.3,1.3,0,0,0-2,1,.9.9,0,0,1,.87.09,2,2,0,0,1,.84,1.73c0,1.11-.65,1.36-1.22,1A2.51,2.51,0,0,1,357,213.84Zm1.1,2c.35.2.69-.07.69-1a1.28,1.28,0,0,0-.62-1.27.81.81,0,0,0-.68-.14,3.86,3.86,0,0,0,0,.6C357.45,215.05,357.67,215.62,358.1,215.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.44,209.78a.31.31,0,0,1-.13,0l-21.16-12.22a.27.27,0,0,1-.1-.35.26.26,0,0,1,.35-.09l21.16,12.22a.27.27,0,0,1,.1.35A.25.25,0,0,1,360.44,209.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.54,208.52l-.39.24a23.39,23.39,0,0,1-3.18-11.4c0-3.73,1-6.29,3.18-7.74l.39.7a11.47,11.47,0,0,0-2.35,7.74C382.19,201.32,382.74,204,384.54,208.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,199.5l.4-.24a23.45,23.45,0,0,1,3.17,11.4c0,3.72-1,6.29-3.17,7.73l-.4-.7a11.45,11.45,0,0,0,2.35-7.74C402.78,206.7,402.23,204,400.43,199.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.64,199.14c.12.06.19.15.29.43l.06.18a.34.34,0,0,0,.11-.07,4.57,4.57,0,0,0,.72-.83l-.24-1.2c-.07-.34-.11-.46-.22-.53s-.23-.06-.42.27l-.13-.2c.21-.5.46-.62.7-.48s.33.35.43.89l.17.93a5.83,5.83,0,0,1,.61-.79.31.31,0,0,1,.45-.07.93.93,0,0,1,.38.61c0,.21-.11.3-.23.23a.78.78,0,0,1-.31-.43l0-.08s-.05,0-.08.06a5.62,5.62,0,0,0-.72.81l.19,1.06c.09.46.17.58.32.67s.34,0,.54-.22l.14.22c-.27.37-.6.56-.89.39s-.3-.27-.39-.76l-.21-1a4.33,4.33,0,0,1-.63.84.28.28,0,0,1-.39,0,1,1,0,0,1-.46-.79C390.43,199.1,390.55,199.08,390.64,199.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,213.6l-1.08-.63v-.4l1.08.63v-1.54l.32.18v1.54l1.08.63v.39l-1.08-.62v1.57l-.32-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,207.47c.12.07.19.15.29.43l.06.19.11-.08a4.45,4.45,0,0,0,.72-.82l-.24-1.2c-.06-.35-.1-.47-.22-.54s-.23,0-.42.27l-.13-.2c.21-.49.47-.61.7-.48s.33.36.43.89l.17.93a6.79,6.79,0,0,1,.61-.79.33.33,0,0,1,.46-.07.92.92,0,0,1,.37.61c0,.21-.11.3-.23.23s-.2-.16-.31-.43l0-.08s0,0-.08.07a6.19,6.19,0,0,0-.72.8l.2,1.06c.08.46.16.59.32.68s.33,0,.53-.23l.14.22c-.27.37-.6.56-.89.39s-.29-.27-.39-.76l-.21-1a4,4,0,0,1-.63.84.27.27,0,0,1-.39,0,1,1,0,0,1-.46-.79C387,207.44,387.16,207.42,387.25,207.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,208.55l1.29.74v.48l-1.29-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.6,211.93l.82-.56c1-.66,1.24-.94,1.24-1.51a1.36,1.36,0,0,0-.65-1.25.61.61,0,0,0-.43-.1l0,.43c0,.43-.14.48-.29.39a.61.61,0,0,1-.22-.4c.13-.76.5-.9,1.09-.56a2,2,0,0,1,1,1.72c0,.84-.54,1-1.46,1.57l-.64.4,1.73,1-.09.52-2.11-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,204.49l.82-.56c1-.66,1.24-.94,1.24-1.51a1.36,1.36,0,0,0-.65-1.24.6.6,0,0,0-.44-.11l0,.44c0,.42-.13.47-.28.38a.52.52,0,0,1-.22-.4c.13-.76.49-.9,1.09-.55a1.93,1.93,0,0,1,1,1.71c0,.84-.55,1-1.46,1.57l-.65.4,1.74,1-.09.52-2.12-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.28,207.48a.24.24,0,0,1-.12,0l-14.83-8.56a.25.25,0,0,1,.25-.43L399.41,207a.27.27,0,0,1,.09.35A.25.25,0,0,1,399.28,207.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.53,227.57l-.4.23A23.45,23.45,0,0,1,414,216.4c0-3.72,1-6.29,3.17-7.73l.4.7a11.45,11.45,0,0,0-2.35,7.74C415.18,220.37,415.73,223.06,417.53,227.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,218.54l.4-.24A23.48,23.48,0,0,1,437,229.7c0,3.73-1,6.29-3.17,7.74l-.4-.7a11.47,11.47,0,0,0,2.35-7.74C435.77,225.74,435.22,223,433.42,218.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.58,218.73c.12.07.19.16.29.43l.06.19.1-.07a4.93,4.93,0,0,0,.73-.83l-.24-1.2c-.07-.35-.11-.47-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.46-.61.7-.47s.33.35.43.88l.17.93a6.65,6.65,0,0,1,.6-.78c.17-.16.29-.18.46-.07a.88.88,0,0,1,.38.61c0,.21-.11.29-.23.22s-.2-.16-.31-.43l0-.08-.08.07a6.12,6.12,0,0,0-.72.8l.19,1.06c.09.46.17.59.32.68s.34,0,.54-.23l.14.23c-.27.37-.6.56-.9.39s-.29-.28-.38-.76l-.21-1.05a4.79,4.79,0,0,1-.63.85.28.28,0,0,1-.39,0,1,1,0,0,1-.46-.79C424.37,218.7,424.49,218.68,424.58,218.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.24,226.51c.12.07.19.16.29.44l.06.18a.34.34,0,0,0,.11-.07,4.53,4.53,0,0,0,.72-.83l-.24-1.2c-.06-.34-.1-.46-.22-.53s-.23-.06-.42.26l-.13-.2c.21-.49.47-.61.7-.47s.33.35.43.89l.17.92a6.28,6.28,0,0,1,.61-.78.33.33,0,0,1,.46-.07.89.89,0,0,1,.37.61c0,.21-.11.3-.23.23a.78.78,0,0,1-.31-.43l0-.08s-.05,0-.08.06a5.62,5.62,0,0,0-.72.81l.2,1.06c.08.45.16.58.32.67s.33,0,.53-.22l.14.22c-.27.37-.6.56-.89.39s-.29-.27-.39-.76l-.21-1a4.24,4.24,0,0,1-.63.84.29.29,0,0,1-.39,0,1,1,0,0,1-.46-.8C420,226.48,420.15,226.46,420.24,226.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.65,228.08l-1.08-.62v-.4l1.08.63v-1.54l.32.18v1.54l1.08.62v.4l-1.08-.62v1.57l-.32-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,231.68l.82-.56c1-.66,1.24-.94,1.24-1.51a1.35,1.35,0,0,0-.64-1.24.59.59,0,0,0-.44-.1l0,.43c0,.42-.13.47-.28.38a.54.54,0,0,1-.23-.4c.14-.76.5-.9,1.1-.55a2,2,0,0,1,1,1.71c0,.84-.55,1-1.46,1.57l-.65.41,1.74,1-.09.52-2.12-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,223.54l.82-.56c1-.67,1.25-.95,1.25-1.51a1.36,1.36,0,0,0-.65-1.25.64.64,0,0,0-.44-.1l0,.43c0,.43-.13.48-.28.39a.58.58,0,0,1-.23-.41c.14-.75.5-.89,1.1-.55a1.93,1.93,0,0,1,1,1.71c0,.84-.55,1-1.46,1.57l-.65.41,1.74,1-.09.53L437.88,224Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.43,238.45l1.1-.75c1.31-.89,1.66-1.27,1.66-2a1.81,1.81,0,0,0-.87-1.67.79.79,0,0,0-.58-.14l-.06.58c0,.57-.18.64-.38.52a.77.77,0,0,1-.3-.54c.18-1,.67-1.21,1.47-.74a2.58,2.58,0,0,1,1.31,2.29c0,1.13-.73,1.36-1.95,2.11l-.87.55,2.33,1.34-.12.7L448.33,239Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09,227a.2.2,0,0,1-.13,0l-15.64-9a.26.26,0,0,1-.09-.35.25.25,0,0,1,.34-.09l15.64,9a.25.25,0,0,1-.12.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.73,231.67v-.39l2.49,1.43v.4Zm0,1.49v-.39l2.49,1.43v.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.69,279.41a.2.2,0,0,1-.11,0l-44-25.39a.24.24,0,0,1-.11-.23.22.22,0,0,1,.17-.19l44-10.5a.22.22,0,0,1,.19.05.2.2,0,0,1,.09.17v35.9a.22.22,0,0,1-.12.19A.2.2,0,0,1,361.69,279.41Zm-43.38-25.53,43.16,24.91V243.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,267.17a1.54,1.54,0,0,1,.49.56l0,0a1.4,1.4,0,0,0,.53-.27,2.27,2.27,0,0,0,.32-.3c-.05-1-.12-1.54-.22-2.66s-.13-1.2-.23-1.26-.19,0-.4.3l-.14-.21c.24-.54.51-.66.76-.51s.35.37.42,1.3.12,1.81.14,2.56a7.46,7.46,0,0,0,.82-2c.2-.8.29-.92.45-.82a.46.46,0,0,1,.22.4,1.05,1.05,0,0,1-.14.56c-.13.27-.26.52-.48.93s-.48.87-.8,1.34a3.49,3.49,0,0,1-.57.68c-.39.34-.74.48-1.08.28a.85.85,0,0,1-.43-.7C366.46,267.13,366.59,267.08,366.75,267.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,270.29l.51-.35c.61-.41.78-.59.78-.94a.85.85,0,0,0-.41-.78.36.36,0,0,0-.27-.06l0,.27c0,.26-.08.29-.17.24a.36.36,0,0,1-.14-.26c.08-.47.31-.55.68-.34a1.23,1.23,0,0,1,.61,1.07c0,.52-.34.63-.91,1l-.4.25,1.08.63-.05.33-1.33-.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,266.79l2.57,1.49v.51l-2.57-1.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,272.42a1.63,1.63,0,0,1,.48.56l0,0a1.37,1.37,0,0,0,.54-.27,2.15,2.15,0,0,0,.32-.29c-.05-1-.12-1.55-.22-2.67s-.13-1.19-.24-1.25-.18,0-.4.29l-.13-.21c.23-.53.5-.65.75-.51s.36.38.43,1.31.11,1.8.14,2.56a7.94,7.94,0,0,0,.82-2c.19-.81.28-.92.45-.82a.46.46,0,0,1,.22.4,1.06,1.06,0,0,1-.15.55,9.43,9.43,0,0,1-.48.94,13.83,13.83,0,0,1-.8,1.34,3.73,3.73,0,0,1-.56.68c-.39.34-.74.48-1.09.28a.88.88,0,0,1-.42-.71C375.55,272.38,375.67,272.32,375.84,272.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,273.46l0,.07-.11.59-.21,1.24c0,.23-.07.46-.11.68l.52.37,0,.15-1.26-.73,0-.15.49.22.37-2.23-.48-.22,0-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23,277.84c.13.07.21.16.31.46l.06.2a.32.32,0,0,0,.12-.08,5.11,5.11,0,0,0,.77-.88l-.25-1.29c-.07-.37-.11-.49-.24-.57s-.25-.06-.45.29l-.14-.22c.22-.52.5-.65.75-.51s.35.38.46.95l.19,1a5.47,5.47,0,0,1,.64-.84c.18-.17.3-.19.49-.08a1,1,0,0,1,.4.65c0,.23-.11.32-.24.25a.8.8,0,0,1-.33-.47l0-.08-.08.07a6.37,6.37,0,0,0-.77.86l.21,1.14c.09.49.17.62.34.72s.36,0,.57-.24l.15.23c-.29.4-.64.61-.95.42s-.31-.29-.42-.81l-.22-1.11a5.51,5.51,0,0,1-.67.9.31.31,0,0,1-.42,0A1.07,1.07,0,0,1,344,278C344,277.8,344.14,277.78,344.23,277.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,282.72l.51-.35c.61-.41.78-.59.78-.94a.85.85,0,0,0-.41-.78.36.36,0,0,0-.27-.06l0,.26c0,.27-.09.3-.18.25a.39.39,0,0,1-.14-.26c.08-.47.31-.56.68-.34a1.2,1.2,0,0,1,.62,1.07c0,.52-.35.63-.92,1l-.4.25,1.08.63-.05.32-1.32-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.23,279.22l2.58,1.48v.51l-2.58-1.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.58,283.23a.75.75,0,0,1,.3.47l.07.19a.26.26,0,0,0,.11-.07,4.79,4.79,0,0,0,.77-.89l-.25-1.28c-.07-.37-.11-.5-.24-.57s-.24-.06-.44.28l-.14-.22c.22-.52.49-.65.74-.5s.36.38.46.95l.19,1a6.79,6.79,0,0,1,.65-.84.35.35,0,0,1,.49-.08,1,1,0,0,1,.4.66c0,.22-.12.32-.25.24a.81.81,0,0,1-.33-.46l0-.09-.09.08a5.82,5.82,0,0,0-.77.86l.21,1.13c.09.49.17.63.34.72s.36,0,.58-.24l.14.24c-.28.4-.63.6-.95.42s-.31-.29-.41-.81l-.23-1.12a4.65,4.65,0,0,1-.67.9.31.31,0,0,1-.42,0,1.05,1.05,0,0,1-.49-.85A.17.17,0,0,1,353.58,283.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,286l0,.07-.11.6-.21,1.24c0,.23-.07.46-.11.68l.52.37,0,.15-1.26-.73,0-.15.49.22.37-2.23L357,286l0-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.73,231.13c0-1.65.66-2.76,2-3.17l.14.33c-1.09.53-1.63,1.45-1.63,3.13a9.22,9.22,0,0,0,.64,3.26l-.2,0A8.74,8.74,0,0,1,352.73,231.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.59,232.85c.13.07.21.16.31.46l.07.2a.38.38,0,0,0,.11-.08,5.11,5.11,0,0,0,.77-.88l-.25-1.29c-.07-.37-.11-.49-.24-.57s-.25-.06-.45.29l-.14-.22c.22-.53.5-.65.75-.51s.35.38.46.95l.19,1a5.47,5.47,0,0,1,.64-.84.34.34,0,0,1,.49-.08,1,1,0,0,1,.4.65c0,.23-.11.32-.24.25a.81.81,0,0,1-.33-.46l0-.09s0,.05-.08.07a6.37,6.37,0,0,0-.77.86l.21,1.14c.09.49.17.62.34.72s.36,0,.57-.24l.15.23c-.29.4-.64.61-.95.42s-.32-.29-.42-.81l-.22-1.11a5.51,5.51,0,0,1-.67.9.31.31,0,0,1-.42,0,1.07,1.07,0,0,1-.49-.85C354.37,232.81,354.5,232.79,354.59,232.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.66,237.73l.51-.35c.61-.42.78-.59.78-.94a.85.85,0,0,0-.41-.78.36.36,0,0,0-.27-.06l0,.26c0,.27-.09.3-.18.25a.39.39,0,0,1-.14-.26c.08-.47.31-.56.68-.34a1.2,1.2,0,0,1,.62,1.07c0,.52-.35.63-.92,1l-.4.25,1.08.63-.05.32-1.32-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.89,238.28a.94.94,0,0,0,.7-.44l-.17-.36a1.24,1.24,0,0,1-.1-.47c0-.24.1-.4.37-.25a1.08,1.08,0,0,1,.27.26,1,1,0,0,1,.07.35,1.06,1.06,0,0,1-1,1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.91,240.07a1.64,1.64,0,0,1,.49.56v0a1.38,1.38,0,0,0,.54-.27,2.27,2.27,0,0,0,.32-.3c0-1-.12-1.54-.22-2.66s-.13-1.2-.23-1.26-.19,0-.41.29l-.13-.2c.24-.54.51-.66.76-.51s.35.37.42,1.3.11,1.8.14,2.56a7.59,7.59,0,0,0,.82-2c.19-.8.28-.92.45-.82a.46.46,0,0,1,.22.4,1.1,1.1,0,0,1-.15.56c-.12.27-.25.52-.47.93s-.48.87-.81,1.34a3.36,3.36,0,0,1-.56.68c-.39.34-.74.48-1.09.28a.88.88,0,0,1-.42-.71C363.62,240,363.74,240,363.91,240.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,243.19l.51-.35c.61-.42.78-.59.78-.94a.85.85,0,0,0-.41-.78.36.36,0,0,0-.27-.06l0,.26c0,.27-.08.3-.17.25a.36.36,0,0,1-.14-.26c.08-.47.31-.56.68-.34a1.21,1.21,0,0,1,.61,1.07c0,.52-.34.63-.91,1l-.41.25,1.09.63-.05.32-1.33-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.48,240.73c0,1.65-.65,2.77-2,3.17l-.14-.33c1.09-.53,1.62-1.45,1.62-3.13a9.27,9.27,0,0,0-.64-3.26l.2-.05A8.81,8.81,0,0,1,371.48,240.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,243.15c0-1.65.65-2.76,1.95-3.17l.14.33c-1.09.53-1.63,1.45-1.63,3.13a9.25,9.25,0,0,0,.65,3.26l-.21.05A8.72,8.72,0,0,1,297.1,243.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,244.87c.12.07.2.16.3.46l.07.2a.38.38,0,0,0,.11-.08,4.72,4.72,0,0,0,.77-.88l-.25-1.29c-.07-.37-.11-.5-.24-.57s-.24-.06-.45.29l-.13-.22c.22-.53.49-.65.74-.51s.36.38.46.95l.19,1a7.8,7.8,0,0,1,.64-.83.34.34,0,0,1,.49-.08,1,1,0,0,1,.41.65c0,.23-.12.32-.25.24s-.22-.17-.33-.46l0-.08-.08.07a6.37,6.37,0,0,0-.77.86l.21,1.14c.09.49.17.62.34.72s.36,0,.57-.24l.15.23c-.28.4-.64.61-.95.42s-.31-.29-.41-.81l-.23-1.11a5,5,0,0,1-.67.9.31.31,0,0,1-.42,0,1.07,1.07,0,0,1-.49-.85C298.73,244.83,298.86,244.81,299,244.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.19,247.67l0,.07-.11.6-.21,1.23c0,.23-.07.46-.11.69l.52.37,0,.14L302,250l0-.15.49.22.37-2.22-.48-.23,0-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,250.3a.92.92,0,0,0,.7-.44l-.16-.36a1.08,1.08,0,0,1-.11-.47c0-.24.11-.4.37-.25a1.23,1.23,0,0,1,.27.25.89.89,0,0,1,.07.36,1.06,1.06,0,0,1-1.05,1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,252.09a1.63,1.63,0,0,1,.48.56l0,0a1.25,1.25,0,0,0,.54-.27,2.09,2.09,0,0,0,.31-.29c-.05-1-.12-1.54-.22-2.66s-.13-1.2-.23-1.26-.19,0-.4.29l-.14-.2c.24-.54.51-.66.76-.51s.35.37.42,1.3.12,1.8.14,2.56a7.59,7.59,0,0,0,.82-2c.2-.8.29-.92.45-.82a.47.47,0,0,1,.23.4,1.1,1.1,0,0,1-.15.56c-.13.27-.26.52-.48.93s-.48.87-.8,1.34a4.19,4.19,0,0,1-.56.68c-.4.34-.75.48-1.09.28a.87.87,0,0,1-.43-.71C308,252.05,308.11,252,308.28,252.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.64,253.13l0,.07-.12.59-.2,1.24c0,.23-.08.46-.11.68l.52.38,0,.14-1.27-.73,0-.15.49.22.37-2.22-.48-.23,0-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,252.75c0,1.65-.65,2.77-1.95,3.17l-.14-.33c1.09-.53,1.63-1.45,1.63-3.13a9.29,9.29,0,0,0-.65-3.26l.2,0A8.78,8.78,0,0,1,315.84,252.75Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363,385.31l-9.41-5.43a2.56,2.56,0,0,0-2.08-.09L342,384.2a3.47,3.47,0,0,1-2.18.14,55.43,55.43,0,0,0-7.4-1.76,1.82,1.82,0,0,1-1.38-1.34L329.82,375a1.48,1.48,0,0,0-1.4-1.16H314.6a1.47,1.47,0,0,0-1.39,1.16l-1.2,6.28a1.82,1.82,0,0,1-1.38,1.34,56.46,56.46,0,0,0-7.39,1.75,3.43,3.43,0,0,1-2.19-.13l-9.53-4.41a2.56,2.56,0,0,0-2.08.09l-9.4,5.43a.77.77,0,0,0-.44.64h0l0,8.15h0a.8.8,0,0,0,.37.64l4.33,3.11a2.11,2.11,0,0,1-1.07.44l-12.53.79a1.27,1.27,0,0,0-1.17,1.25v5.33h0l0,9.81a1.27,1.27,0,0,0,1.18,1.24l12.53.8a2,2,0,0,1,1.08.46l-4.3,3.09a.79.79,0,0,0-.37.63h0l0,8.16h0a.75.75,0,0,0,.43.64l9.41,5.42a2.52,2.52,0,0,0,2.08.1L301,431.6a3.54,3.54,0,0,1,2.18-.13,57,57,0,0,0,7.4,1.76,1.8,1.8,0,0,1,1.38,1.34l1.19,6.28a1.47,1.47,0,0,0,1.4,1.15H328.4a1.46,1.46,0,0,0,1.39-1.15l1.2-6.28a1.79,1.79,0,0,1,1.37-1.34,56.25,56.25,0,0,0,7.4-1.76,3.57,3.57,0,0,1,2.19.13l9.53,4.42a2.52,2.52,0,0,0,2.08-.1l9.4-5.42a.79.79,0,0,0,.44-.63h0l0-8.17h0a.79.79,0,0,0-.37-.63L358.72,418a2,2,0,0,1,1.07-.44l12.53-.8a1.26,1.26,0,0,0,1.17-1.24l0-8.12s0,0,0,0v-7a1.27,1.27,0,0,0-1.18-1.25l-12.53-.79a2.13,2.13,0,0,1-1.09-.46l4.31-3.09a.79.79,0,0,0,.37-.63h0l0-8.16h0A.78.78,0,0,0,363,385.31ZM299.5,406.43c.68-2.25,2.69-4.45,6.12-6.44,8.78-5.06,23-5.06,31.77,0,3.22,1.86,5.32,3.91,6.27,6-.75,2.57-2.83,5-6.26,7-8.78,5.07-23,5.07-31.78,0C302.39,411.13,300.35,408.84,299.5,406.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,385.31l-9.41-5.43a2.56,2.56,0,0,0-2.08-.09L342,384.2a3.47,3.47,0,0,1-2.18.14,55.43,55.43,0,0,0-7.4-1.76,1.82,1.82,0,0,1-1.38-1.34L329.82,375a1.48,1.48,0,0,0-1.4-1.16H314.6a1.47,1.47,0,0,0-1.39,1.16l-1.2,6.28a1.82,1.82,0,0,1-1.38,1.34,56.46,56.46,0,0,0-7.39,1.75,3.43,3.43,0,0,1-2.19-.13l-9.53-4.41a2.56,2.56,0,0,0-2.08.09l-9.4,5.43a.77.77,0,0,0-.44.64h0l0,8.15h0a.8.8,0,0,0,.37.64l4.33,3.11a2.11,2.11,0,0,1-1.07.44l-12.53.79a1.27,1.27,0,0,0-1.17,1.25v5.33h0l0,9.81a1.27,1.27,0,0,0,1.18,1.24l12.53.8a2,2,0,0,1,1.08.46l-4.3,3.09a.79.79,0,0,0-.37.63h0l0,8.16h0a.75.75,0,0,0,.43.64l9.41,5.42a2.52,2.52,0,0,0,2.08.1L301,431.6a3.54,3.54,0,0,1,2.18-.13,57,57,0,0,0,7.4,1.76,1.8,1.8,0,0,1,1.38,1.34l1.19,6.28a1.47,1.47,0,0,0,1.4,1.15H328.4a1.46,1.46,0,0,0,1.39-1.15l1.2-6.28a1.79,1.79,0,0,1,1.37-1.34,56.25,56.25,0,0,0,7.4-1.76,3.57,3.57,0,0,1,2.19.13l9.53,4.42a2.52,2.52,0,0,0,2.08-.1l9.4-5.42a.79.79,0,0,0,.44-.63h0l0-8.17h0a.79.79,0,0,0-.37-.63L358.72,418a2,2,0,0,1,1.07-.44l12.53-.8a1.26,1.26,0,0,0,1.17-1.24l0-8.12s0,0,0,0v-7a1.27,1.27,0,0,0-1.18-1.25l-12.53-.79a2.13,2.13,0,0,1-1.09-.46l4.31-3.09a.79.79,0,0,0,.37-.63h0l0-8.16h0A.78.78,0,0,0,363,385.31ZM299.5,406.43c.68-2.25,2.69-4.45,6.12-6.44,8.78-5.06,23-5.06,31.77,0,3.22,1.86,5.32,3.91,6.27,6-.75,2.57-2.83,5-6.26,7-8.78,5.07-23,5.07-31.78,0C302.39,411.13,300.35,408.84,299.5,406.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9,410.49a2.32,2.32,0,0,0-1.69-1.13l-12.54-.79a1.26,1.26,0,0,1-1.16-1.25v-1.65l0,9.8a1.28,1.28,0,0,0,1.18,1.25l12.53.79a2,2,0,0,1,1.1.46l3.14-2.26a1,1,0,0,0,.13-1.53A19.23,19.23,0,0,1,284.9,410.49Zm-5.33-16.39h0a.78.78,0,0,0,.37.63l4.33,3.11a2.21,2.21,0,0,0,.62-.68,19.41,19.41,0,0,1,2.66-3.7,1,1,0,0,0-.14-1.53L280,386.59a1,1,0,0,1-.38-.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.4,394.66c-8.78-5.07-23-5.07-31.78,0-5.54,3.21-7.58,7.66-6.12,11.79.66-2.25,2.68-4.46,6.12-6.45,8.78-5.07,23-5.06,31.77,0,3.22,1.85,5.32,3.89,6.28,6C344.83,402,342.73,397.74,337.4,394.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.51,407.48a1.3,1.3,0,0,1-1.16,1.09l-12.53.79a1.79,1.79,0,0,0-.63.17l0,8.17a1.67,1.67,0,0,1,.62-.18l12.53-.8a1.25,1.25,0,0,0,1.17-1.24ZM363.43,386h0a.45.45,0,0,1-.05.25.6.6,0,0,1-.15.25.79.79,0,0,1-.17.14l-7.45,5.36a.74.74,0,0,0-.18.17.89.89,0,0,0-.24.46,1.08,1.08,0,0,0,0,.31.75.75,0,0,0,0,.16,1.1,1.1,0,0,0,.25.43,2.09,2.09,0,0,1,.14.17,19.11,19.11,0,0,1,2.52,3.52,2.67,2.67,0,0,0,.59.68l4.32-3.1a.84.84,0,0,0,.37-.62h0Zm0,35.82a.84.84,0,0,1-.44.58l-9.41,5.42a2.45,2.45,0,0,1-1.46.26v8.14a2.5,2.5,0,0,0,1.45-.24l9.4-5.43a.75.75,0,0,0,.44-.62ZM302,423.22a2.88,2.88,0,0,0-.94.23l-9.53,4.42a2.26,2.26,0,0,1-.85.18l0,8.13a2.26,2.26,0,0,0,.85-.16L301,431.6a3,3,0,0,1,.94-.22Zm27.6,10a1.45,1.45,0,0,1-1.16.62H314.59a1.44,1.44,0,0,1-.84-.31v8.15a1.42,1.42,0,0,0,.84.31H328.4a1.5,1.5,0,0,0,1.21-.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.51,407.48a1.3,1.3,0,0,1-1.16,1.09l-12.53.79a1.79,1.79,0,0,0-.63.17l0,8.17a1.67,1.67,0,0,1,.62-.18l12.53-.8a1.25,1.25,0,0,0,1.17-1.24ZM363.43,386h0a.45.45,0,0,1-.05.25.6.6,0,0,1-.15.25.79.79,0,0,1-.17.14l-7.45,5.36a.74.74,0,0,0-.18.17.89.89,0,0,0-.24.46,1.08,1.08,0,0,0,0,.31.75.75,0,0,0,0,.16,1.1,1.1,0,0,0,.25.43,2.09,2.09,0,0,1,.14.17,19.11,19.11,0,0,1,2.52,3.52,2.67,2.67,0,0,0,.59.68l4.32-3.1a.84.84,0,0,0,.37-.62h0Zm0,35.82a.84.84,0,0,1-.44.58l-9.41,5.42a2.45,2.45,0,0,1-1.46.26v8.14a2.5,2.5,0,0,0,1.45-.24l9.4-5.43a.75.75,0,0,0,.44-.62ZM302,423.22a2.88,2.88,0,0,0-.94.23l-9.53,4.42a2.26,2.26,0,0,1-.85.18l0,8.13a2.26,2.26,0,0,0,.85-.16L301,431.6a3,3,0,0,1,.94-.22Zm27.6,10a1.45,1.45,0,0,1-1.16.62H314.59a1.44,1.44,0,0,1-.84-.31v8.15a1.42,1.42,0,0,0,.84.31H328.4a1.5,1.5,0,0,0,1.21-.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,379.79,342,384.2a3.47,3.47,0,0,1-2.18.14,55.43,55.43,0,0,0-7.4-1.76,1.82,1.82,0,0,1-1.38-1.34L329.82,375a1.48,1.48,0,0,0-1.4-1.16H314.6a1.47,1.47,0,0,0-1.39,1.16l-1.2,6.28a1.82,1.82,0,0,1-1.38,1.34,56.46,56.46,0,0,0-7.39,1.75,3.43,3.43,0,0,1-2.19-.13l-9.53-4.41a2.56,2.56,0,0,0-2.08.09l-9.4,5.43a.7.7,0,0,0-.07,1.27l7.46,5.37a1,1,0,0,1,.13,1.53,19,19,0,0,0-2.66,3.69,2.29,2.29,0,0,1-1.69,1.12l-12.53.79a1.27,1.27,0,0,0-1.17,1.25v7a1.26,1.26,0,0,0,1.17,1.25l12.53.79a2.31,2.31,0,0,1,1.69,1.13,18.93,18.93,0,0,0,2.66,3.69,1,1,0,0,1-.13,1.53L280,421.07a.7.7,0,0,0,.07,1.27l9.4,5.43a2.52,2.52,0,0,0,2.08.1l9.53-4.42a3.54,3.54,0,0,1,2.18-.13,57,57,0,0,0,7.4,1.76,1.8,1.8,0,0,1,1.38,1.34l1.19,6.28a1.48,1.48,0,0,0,1.4,1.15h13.82a1.47,1.47,0,0,0,1.4-1.15l1.19-6.28a1.8,1.8,0,0,1,1.38-1.34,57,57,0,0,0,7.4-1.76,3.54,3.54,0,0,1,2.18.13l9.53,4.42a2.52,2.52,0,0,0,2.08-.1l9.41-5.43a.7.7,0,0,0,.06-1.27l-7.45-5.36a1,1,0,0,1-.14-1.53,18.93,18.93,0,0,0,2.66-3.69,2.32,2.32,0,0,1,1.69-1.13l12.53-.79a1.27,1.27,0,0,0,1.18-1.25v-7a1.28,1.28,0,0,0-1.18-1.25l-12.53-.79a2.31,2.31,0,0,1-1.69-1.12,18.63,18.63,0,0,0-2.66-3.69,1,1,0,0,1,.14-1.53l7.45-5.37a.7.7,0,0,0-.06-1.27l-9.41-5.43A2.56,2.56,0,0,0,351.5,379.79Zm-14.1,14.87c8.77,5.06,8.77,13.27,0,18.34s-23,5.07-31.78,0-8.77-13.28,0-18.34S328.62,389.59,337.4,394.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.5,379.79,342,384.2a3.47,3.47,0,0,1-2.18.14,55.43,55.43,0,0,0-7.4-1.76,1.82,1.82,0,0,1-1.38-1.34L329.82,375a1.48,1.48,0,0,0-1.4-1.16H314.6a1.47,1.47,0,0,0-1.39,1.16l-1.2,6.28a1.82,1.82,0,0,1-1.38,1.34,56.46,56.46,0,0,0-7.39,1.75,3.43,3.43,0,0,1-2.19-.13l-9.53-4.41a2.56,2.56,0,0,0-2.08.09l-9.4,5.43a.7.7,0,0,0-.07,1.27l7.46,5.37a1,1,0,0,1,.13,1.53,19,19,0,0,0-2.66,3.69,2.29,2.29,0,0,1-1.69,1.12l-12.53.79a1.27,1.27,0,0,0-1.17,1.25v7a1.26,1.26,0,0,0,1.17,1.25l12.53.79a2.31,2.31,0,0,1,1.69,1.13,18.93,18.93,0,0,0,2.66,3.69,1,1,0,0,1-.13,1.53L280,421.07a.7.7,0,0,0,.07,1.27l9.4,5.43a2.52,2.52,0,0,0,2.08.1l9.53-4.42a3.54,3.54,0,0,1,2.18-.13,57,57,0,0,0,7.4,1.76,1.8,1.8,0,0,1,1.38,1.34l1.19,6.28a1.48,1.48,0,0,0,1.4,1.15h13.82a1.47,1.47,0,0,0,1.4-1.15l1.19-6.28a1.8,1.8,0,0,1,1.38-1.34,57,57,0,0,0,7.4-1.76,3.54,3.54,0,0,1,2.18.13l9.53,4.42a2.52,2.52,0,0,0,2.08-.1l9.41-5.43a.7.7,0,0,0,.06-1.27l-7.45-5.36a1,1,0,0,1-.14-1.53,18.93,18.93,0,0,0,2.66-3.69,2.32,2.32,0,0,1,1.69-1.13l12.53-.79a1.27,1.27,0,0,0,1.18-1.25v-7a1.28,1.28,0,0,0-1.18-1.25l-12.53-.79a2.31,2.31,0,0,1-1.69-1.12,18.63,18.63,0,0,0-2.66-3.69,1,1,0,0,1,.14-1.53l7.45-5.37a.7.7,0,0,0-.06-1.27l-9.41-5.43A2.56,2.56,0,0,0,351.5,379.79Zm-14.1,14.87c8.77,5.06,8.77,13.27,0,18.34s-23,5.07-31.78,0-8.77-13.28,0-18.34S328.62,389.59,337.4,394.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,434.19H314.6a1.79,1.79,0,0,1-1.72-1.43l-1.2-6.28a1.48,1.48,0,0,0-1.1-1.07,58.34,58.34,0,0,1-7.45-1.77,3.21,3.21,0,0,0-1.94.11l-9.53,4.42a2.86,2.86,0,0,1-2.39-.11l-9.4-5.43a1.11,1.11,0,0,1-.61-.89,1.12,1.12,0,0,1,.52-.94l7.45-5.36a.69.69,0,0,0,.29-.48.74.74,0,0,0-.2-.56,18.81,18.81,0,0,1-2.71-3.75,2,2,0,0,0-1.42-.95l-12.53-.8a1.61,1.61,0,0,1-1.49-1.58v-7a1.61,1.61,0,0,1,1.49-1.58l12.53-.79a2,2,0,0,0,1.42-.95,18.76,18.76,0,0,1,2.71-3.76.74.74,0,0,0,.2-.56.65.65,0,0,0-.29-.47l-7.45-5.37a1.09,1.09,0,0,1-.52-.94,1.12,1.12,0,0,1,.61-.89l9.4-5.43a2.93,2.93,0,0,1,2.39-.11l9.53,4.42a3.24,3.24,0,0,0,1.95.12,55.8,55.8,0,0,1,7.44-1.77,1.48,1.48,0,0,0,1.1-1.07l1.2-6.29a1.78,1.78,0,0,1,1.72-1.42h13.82a1.8,1.8,0,0,1,1.73,1.42l1.19,6.28a1.47,1.47,0,0,0,1.1,1.08,56.32,56.32,0,0,1,7.45,1.77,3.21,3.21,0,0,0,1.94-.12l9.53-4.42a2.93,2.93,0,0,1,2.39.11l9.4,5.43a1.12,1.12,0,0,1,.61.89,1.1,1.1,0,0,1-.51.94l-7.46,5.37a.65.65,0,0,0-.29.47.71.71,0,0,0,.21.56,18.81,18.81,0,0,1,2.7,3.76,2,2,0,0,0,1.42.95l12.54.79a1.61,1.61,0,0,1,1.48,1.58v7a1.61,1.61,0,0,1-1.48,1.58l-12.54.8a2,2,0,0,0-1.42.95,19.1,19.1,0,0,1-2.7,3.76.68.68,0,0,0-.21.55.69.69,0,0,0,.29.48l7.45,5.36a1,1,0,0,1-.09,1.83l-9.4,5.43a2.85,2.85,0,0,1-2.39.11l-9.53-4.42a3.21,3.21,0,0,0-1.94-.11,58.34,58.34,0,0,1-7.45,1.77,1.48,1.48,0,0,0-1.1,1.07l-1.19,6.28A1.81,1.81,0,0,1,328.42,434.19Zm-26.06-11.32a3.25,3.25,0,0,1,1,.13,55.34,55.34,0,0,0,7.36,1.75,2.14,2.14,0,0,1,1.65,1.61l1.19,6.28a1.15,1.15,0,0,0,1.07.88h13.82a1.15,1.15,0,0,0,1.07-.88l1.19-6.28a2.14,2.14,0,0,1,1.65-1.61,55.34,55.34,0,0,0,7.36-1.75,3.78,3.78,0,0,1,2.42.15l9.53,4.41a2.19,2.19,0,0,0,1.77-.08l9.41-5.43a.46.46,0,0,0,.27-.34c0-.12-.08-.25-.24-.37L355.4,416a1.32,1.32,0,0,1-.57-1,1.4,1.4,0,0,1,.38-1.08,18.22,18.22,0,0,0,2.62-3.62,2.64,2.64,0,0,1,2-1.3l12.53-.79a.93.93,0,0,0,.86-.92v-7a.92.92,0,0,0-.86-.91l-12.53-.79a2.64,2.64,0,0,1-2-1.3,18.57,18.57,0,0,0-2.62-3.63,1.39,1.39,0,0,1-.38-1.08,1.37,1.37,0,0,1,.57-.95l7.45-5.36a.46.46,0,0,0,.24-.37.47.47,0,0,0-.27-.34l-9.41-5.43a2.23,2.23,0,0,0-1.77-.08l-9.53,4.42a3.78,3.78,0,0,1-2.42.14,56.55,56.55,0,0,0-7.36-1.74,2.16,2.16,0,0,1-1.65-1.61L329.49,375a1.14,1.14,0,0,0-1.07-.88H314.6a1.14,1.14,0,0,0-1.07.88l-1.19,6.28a2.14,2.14,0,0,1-1.65,1.61,56.55,56.55,0,0,0-7.36,1.74,3.85,3.85,0,0,1-2.42-.14l-9.53-4.42a2.23,2.23,0,0,0-1.77.08l-9.41,5.43a.5.5,0,0,0-.27.34.46.46,0,0,0,.24.37l7.45,5.36a1.35,1.35,0,0,1,.57.95,1.39,1.39,0,0,1-.38,1.08,18.51,18.51,0,0,0-2.61,3.63,2.63,2.63,0,0,1-2,1.29l-12.53.8a.93.93,0,0,0-.86.91v7a.93.93,0,0,0,.86.92l12.53.79a2.64,2.64,0,0,1,2,1.3,18.57,18.57,0,0,0,2.61,3.62,1.4,1.4,0,0,1,.38,1.08,1.32,1.32,0,0,1-.57,1l-7.45,5.36c-.16.12-.25.25-.24.37a.48.48,0,0,0,.27.34l9.41,5.43a2.19,2.19,0,0,0,1.77.08l9.53-4.41A3.47,3.47,0,0,1,302.36,422.87Zm19.15-5.75c-5.81,0-11.63-1.27-16.05-3.83s-6.75-5.87-6.75-9.46,2.4-6.95,6.75-9.46c8.85-5.12,23.25-5.12,32.1,0h0c4.36,2.51,6.75,5.87,6.75,9.46s-2.39,6.95-6.75,9.46S327.32,417.12,321.51,417.12Zm0-25.93A32.06,32.06,0,0,0,305.79,395c-4.13,2.38-6.41,5.54-6.41,8.88s2.28,6.49,6.41,8.88c8.67,5,22.77,5,31.44,0,4.14-2.39,6.41-5.54,6.41-8.88s-2.27-6.5-6.41-8.88h0A32.06,32.06,0,0,0,321.51,391.19Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.52,414.1a1.89,1.89,0,0,1-1.3-2l.4-3.3a1.53,1.53,0,0,0-1.36-1.7l-8.7-.91a2.44,2.44,0,0,0-2.25,1.22l-1.73,3.37a3,3,0,0,1-2.25,1.47c-1.52.12-3,.3-4.51.56a4.44,4.44,0,0,1-2.81-.56l-4.68-3.11a3.31,3.31,0,0,0-2.73-.28l-7,2.79a1,1,0,0,0-.72.89h0v.09h0v7.11h0a1.09,1.09,0,0,0,.34.78l.4.43a3.61,3.61,0,0,1-1.91.59l-8-.32a2.15,2.15,0,0,0-2,1.42l-1.2,3.84a1.14,1.14,0,0,0-.05.48h0v7.18h0a1.31,1.31,0,0,0,1.13,1.25l6.16,1.05-2.4,1.21a1,1,0,0,0-.63.87h0v7.19h0a1.11,1.11,0,0,0,.43.79l4.45,3.7a3.18,3.18,0,0,0,2.67.53l6.77-2.12a4.73,4.73,0,0,1,2.88.18,33.93,33.93,0,0,0,3.63,1.34,1.87,1.87,0,0,1,.89.63v4.85h0a1.51,1.51,0,0,0,1.36,1.49l8.7.91a2.43,2.43,0,0,0,2.24-1.22l1.74-3.38a3,3,0,0,1,2.25-1.46c1.52-.12,3-.3,4.51-.56a4.44,4.44,0,0,1,2.81.56l4.68,3.11a3.31,3.31,0,0,0,2.73.28l7-2.79a1,1,0,0,0,.72-.93h0v-7.17h0a1.15,1.15,0,0,0-.34-.77l-.41-.43a3.64,3.64,0,0,1,1.92-.59l8,.32a2.15,2.15,0,0,0,2-1.42l1.2-3.84a1.37,1.37,0,0,0,.06-.44h0v-7.15h0a1.28,1.28,0,0,0-1.1-1.33l-6.16-1,2.4-1.21a1,1,0,0,0,.62-.89h0v-7.15h0a1.08,1.08,0,0,0-.44-.83l-4.44-3.7a3.18,3.18,0,0,0-2.67-.53L433,415.62a4.73,4.73,0,0,1-2.88-.18A33.93,33.93,0,0,0,426.52,414.1Zm-28.88,18a12.89,12.89,0,0,1,5.94-4.31c7.55-3,17.91-1.94,23.14,2.42a9.82,9.82,0,0,1,1.77,1.87,12.91,12.91,0,0,1-5.95,4.33c-7.55,3-17.91,1.94-23.15-2.42A9.56,9.56,0,0,1,397.64,432.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.52,414.1a1.89,1.89,0,0,1-1.3-2l.4-3.3a1.53,1.53,0,0,0-1.36-1.7l-8.7-.91a2.44,2.44,0,0,0-2.25,1.22l-1.73,3.37a3,3,0,0,1-2.25,1.47c-1.52.12-3,.3-4.51.56a4.44,4.44,0,0,1-2.81-.56l-4.68-3.11a3.31,3.31,0,0,0-2.73-.28l-7,2.79a1,1,0,0,0-.72.89h0v.09h0v7.11h0a1.09,1.09,0,0,0,.34.78l.4.43a3.61,3.61,0,0,1-1.91.59l-8-.32a2.15,2.15,0,0,0-2,1.42l-1.2,3.84a1.14,1.14,0,0,0-.05.48h0v7.18h0a1.31,1.31,0,0,0,1.13,1.25l6.16,1.05-2.4,1.21a1,1,0,0,0-.63.87h0v7.19h0a1.11,1.11,0,0,0,.43.79l4.45,3.7a3.18,3.18,0,0,0,2.67.53l6.77-2.12a4.73,4.73,0,0,1,2.88.18,33.93,33.93,0,0,0,3.63,1.34,1.87,1.87,0,0,1,.89.63v4.85h0a1.51,1.51,0,0,0,1.36,1.49l8.7.91a2.43,2.43,0,0,0,2.24-1.22l1.74-3.38a3,3,0,0,1,2.25-1.46c1.52-.12,3-.3,4.51-.56a4.44,4.44,0,0,1,2.81.56l4.68,3.11a3.31,3.31,0,0,0,2.73.28l7-2.79a1,1,0,0,0,.72-.93h0v-7.17h0a1.15,1.15,0,0,0-.34-.77l-.41-.43a3.64,3.64,0,0,1,1.92-.59l8,.32a2.15,2.15,0,0,0,2-1.42l1.2-3.84a1.37,1.37,0,0,0,.06-.44h0v-7.15h0a1.28,1.28,0,0,0-1.1-1.33l-6.16-1,2.4-1.21a1,1,0,0,0,.62-.89h0v-7.15h0a1.08,1.08,0,0,0-.44-.83l-4.44-3.7a3.18,3.18,0,0,0-2.67-.53L433,415.62a4.73,4.73,0,0,1-2.88-.18A33.93,33.93,0,0,0,426.52,414.1Zm-28.88,18a12.89,12.89,0,0,1,5.94-4.31c7.55-3,17.91-1.94,23.14,2.42a9.82,9.82,0,0,1,1.77,1.87,12.91,12.91,0,0,1-5.95,4.33c-7.55,3-17.91,1.94-23.15-2.42A9.56,9.56,0,0,1,397.64,432.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,431.32a2.62,2.62,0,0,0-1.85-1.77l-7.57-1.3a1.29,1.29,0,0,1-1.12-1.18v7.1a1.31,1.31,0,0,0,1.12,1.25l6.17,1.06,3.19-1.61a1.5,1.5,0,0,0,.63-2.05A10.15,10.15,0,0,1,385.06,431.32Zm1.85-11.56h0a1.13,1.13,0,0,0,.33.78l.41.44a3,3,0,0,0,.66-.51,15.92,15.92,0,0,1,1.91-1.7,1.34,1.34,0,0,0,.19-2l-3.16-3.35a1.09,1.09,0,0,1-.34-.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.58,420.66c-6.51,2.61-8.8,7.41-5.93,11.47a12.79,12.79,0,0,1,5.93-4.3c7.55-3,17.91-1.95,23.15,2.41a10.09,10.09,0,0,1,1.76,1.87c2-2.88,1.55-6.29-1.76-9C421.49,418.71,411.13,417.64,403.58,420.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.27,445.44a2.37,2.37,0,0,0-.72.84l-1.75,3.38a2.44,2.44,0,0,1-1.28,1.07v7.17a2.37,2.37,0,0,0,1.28-1.08l1.74-3.38a2.58,2.58,0,0,1,.74-.82Zm23.94-.95h0a1,1,0,0,1-.72.94l-7,2.79a3.27,3.27,0,0,1-1.82.07v7.16a3.22,3.22,0,0,0,1.83-.07l7-2.79a1,1,0,0,0,.71-.92Zm-46.21-3-6.68,2.1a3,3,0,0,1-1.68,0v7.15a3.05,3.05,0,0,0,1.69.05l6.69-2.1Zm58.61-11.33a1.67,1.67,0,0,1-.07.42l-1.2,3.85a2.12,2.12,0,0,1-2,1.41l-7.95-.32a3.31,3.31,0,0,0-1.24.25v7.17a3.38,3.38,0,0,1,1.24-.25l8,.32a2.16,2.16,0,0,0,2-1.41l1.2-3.85a1.39,1.39,0,0,0,.07-.44Zm-4.25-11.61a.74.74,0,0,1-.05.25.84.84,0,0,1-.25.37,1.64,1.64,0,0,1-.35.24l-5.58,2.81a1,1,0,0,0-.34.24,1.46,1.46,0,0,0-.38.58,1.49,1.49,0,0,0-.08.56l0,.29c0,.13.08.25.13.38a9.8,9.8,0,0,1,.57,1.5,2.61,2.61,0,0,0,1.85,1.78l1.4.23,2.41-1.19a1,1,0,0,0,.62-.89h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.27,445.44a2.37,2.37,0,0,0-.72.84l-1.75,3.38a2.44,2.44,0,0,1-1.28,1.07v7.17a2.37,2.37,0,0,0,1.28-1.08l1.74-3.38a2.58,2.58,0,0,1,.74-.82Zm23.94-.95h0a1,1,0,0,1-.72.94l-7,2.79a3.27,3.27,0,0,1-1.82.07v7.16a3.22,3.22,0,0,0,1.83-.07l7-2.79a1,1,0,0,0,.71-.92Zm-46.21-3-6.68,2.1a3,3,0,0,1-1.68,0v7.15a3.05,3.05,0,0,0,1.69.05l6.69-2.1Zm58.61-11.33a1.67,1.67,0,0,1-.07.42l-1.2,3.85a2.12,2.12,0,0,1-2,1.41l-7.95-.32a3.31,3.31,0,0,0-1.24.25v7.17a3.38,3.38,0,0,1,1.24-.25l8,.32a2.16,2.16,0,0,0,2-1.41l1.2-3.85a1.39,1.39,0,0,0,.07-.44Zm-4.25-11.61a.74.74,0,0,1-.05.25.84.84,0,0,1-.25.37,1.64,1.64,0,0,1-.35.24l-5.58,2.81a1,1,0,0,0-.34.24,1.46,1.46,0,0,0-.38.58,1.49,1.49,0,0,0-.08.56l0,.29c0,.13.08.25.13.38a9.8,9.8,0,0,1,.57,1.5,2.61,2.61,0,0,0,1.85,1.78l1.4.23,2.41-1.19a1,1,0,0,0,.62-.89h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.8,413.5,433,415.62a4.73,4.73,0,0,1-2.88-.18,33.93,33.93,0,0,0-3.63-1.34,1.89,1.89,0,0,1-1.3-2l.4-3.3a1.53,1.53,0,0,0-1.36-1.7l-8.7-.91a2.44,2.44,0,0,0-2.25,1.22l-1.73,3.37a3,3,0,0,1-2.25,1.47c-1.52.12-3,.3-4.51.56a4.44,4.44,0,0,1-2.81-.56l-4.68-3.11a3.31,3.31,0,0,0-2.73-.28l-7,2.79a1,1,0,0,0-.38,1.7l3.16,3.36a1.35,1.35,0,0,1-.19,2,17.62,17.62,0,0,0-1.91,1.7,3.86,3.86,0,0,1-2.57,1.09l-8-.32a2.15,2.15,0,0,0-2,1.42l-1.2,3.84a1.31,1.31,0,0,0,1.06,1.74l7.57,1.3a2.57,2.57,0,0,1,1.84,1.77,11.61,11.61,0,0,0,.57,1.51,1.51,1.51,0,0,1-.63,2.05l-5.59,2.8a.93.93,0,0,0-.19,1.68l4.44,3.7a3.15,3.15,0,0,0,2.67.53l6.77-2.12a4.73,4.73,0,0,1,2.88.19A36.2,36.2,0,0,0,399.6,443a1.89,1.89,0,0,1,1.3,2l-.4,3.31a1.52,1.52,0,0,0,1.36,1.69l8.7.91a2.43,2.43,0,0,0,2.25-1.22l1.73-3.37a3,3,0,0,1,2.25-1.47c1.52-.12,3-.3,4.51-.56a4.44,4.44,0,0,1,2.81.56l4.68,3.11a3.27,3.27,0,0,0,2.73.28l7-2.79a1,1,0,0,0,.38-1.7l-3.16-3.36a1.34,1.34,0,0,1,.19-2,18.69,18.69,0,0,0,1.91-1.69,3.87,3.87,0,0,1,2.57-1.1l8,.32a2.14,2.14,0,0,0,2-1.41l1.2-3.85a1.31,1.31,0,0,0-1.06-1.74l-7.57-1.29a2.6,2.6,0,0,1-1.84-1.78,10.28,10.28,0,0,0-.58-1.5,1.52,1.52,0,0,1,.64-2l5.59-2.81a.93.93,0,0,0,.19-1.68l-4.44-3.7A3.18,3.18,0,0,0,439.8,413.5Zm-13.08,9.57c5.24,4.36,3.37,10.34-4.18,13.37s-17.91,1.94-23.15-2.42-3.36-10.34,4.19-13.36S421.49,418.72,426.72,423.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.8,413.5,433,415.62a4.73,4.73,0,0,1-2.88-.18,33.93,33.93,0,0,0-3.63-1.34,1.89,1.89,0,0,1-1.3-2l.4-3.3a1.53,1.53,0,0,0-1.36-1.7l-8.7-.91a2.44,2.44,0,0,0-2.25,1.22l-1.73,3.37a3,3,0,0,1-2.25,1.47c-1.52.12-3,.3-4.51.56a4.44,4.44,0,0,1-2.81-.56l-4.68-3.11a3.31,3.31,0,0,0-2.73-.28l-7,2.79a1,1,0,0,0-.38,1.7l3.16,3.36a1.35,1.35,0,0,1-.19,2,17.62,17.62,0,0,0-1.91,1.7,3.86,3.86,0,0,1-2.57,1.09l-8-.32a2.15,2.15,0,0,0-2,1.42l-1.2,3.84a1.31,1.31,0,0,0,1.06,1.74l7.57,1.3a2.57,2.57,0,0,1,1.84,1.77,11.61,11.61,0,0,0,.57,1.51,1.51,1.51,0,0,1-.63,2.05l-5.59,2.8a.93.93,0,0,0-.19,1.68l4.44,3.7a3.15,3.15,0,0,0,2.67.53l6.77-2.12a4.73,4.73,0,0,1,2.88.19A36.2,36.2,0,0,0,399.6,443a1.89,1.89,0,0,1,1.3,2l-.4,3.31a1.52,1.52,0,0,0,1.36,1.69l8.7.91a2.43,2.43,0,0,0,2.25-1.22l1.73-3.37a3,3,0,0,1,2.25-1.47c1.52-.12,3-.3,4.51-.56a4.44,4.44,0,0,1,2.81.56l4.68,3.11a3.27,3.27,0,0,0,2.73.28l7-2.79a1,1,0,0,0,.38-1.7l-3.16-3.36a1.34,1.34,0,0,1,.19-2,18.69,18.69,0,0,0,1.91-1.69,3.87,3.87,0,0,1,2.57-1.1l8,.32a2.14,2.14,0,0,0,2-1.41l1.2-3.85a1.31,1.31,0,0,0-1.06-1.74l-7.57-1.29a2.6,2.6,0,0,1-1.84-1.78,10.28,10.28,0,0,0-.58-1.5,1.52,1.52,0,0,1,.64-2l5.59-2.81a.93.93,0,0,0,.19-1.68l-4.44-3.7A3.18,3.18,0,0,0,439.8,413.5Zm-13.08,9.57c5.24,4.36,3.37,10.34-4.18,13.37s-17.91,1.94-23.15-2.42-3.36-10.34,4.19-13.36S421.49,418.72,426.72,423.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,451.31h-.23l-8.7-.91a2,2,0,0,1-1.33-.72,2,2,0,0,1-.41-1.46l.4-3.3a1.45,1.45,0,0,0-1-1.5,36.77,36.77,0,0,1-3.67-1.36,4.48,4.48,0,0,0-2.58-.17L386.45,444a3.6,3.6,0,0,1-3.08-.6l-4.44-3.7a1.49,1.49,0,0,1-.59-1.29,1.47,1.47,0,0,1,.87-1.12l5.58-2.8a1.08,1.08,0,0,0,.44-1.48,10.29,10.29,0,0,1-.59-1.57,2.16,2.16,0,0,0-1.51-1.47l-7.56-1.29a1.73,1.73,0,0,1-1.24-.82,1.78,1.78,0,0,1-.17-1.48l1.21-3.84a2.59,2.59,0,0,1,2.44-1.72l7.95.32a3.5,3.5,0,0,0,2.25-1,18.28,18.28,0,0,1,1.95-1.74,1,1,0,0,0,.41-.71.9.9,0,0,0-.27-.69l-3.16-3.36a1.54,1.54,0,0,1-.43-1.36,1.48,1.48,0,0,1,1-1l7-2.79a3.74,3.74,0,0,1,3.13.32l4.68,3.11a4,4,0,0,0,2.5.5c1.47-.26,3-.45,4.54-.57a2.63,2.63,0,0,0,1.91-1.23l1.73-3.38a2.89,2.89,0,0,1,2.68-1.45l8.7.91a1.91,1.91,0,0,1,1.32.72,2,2,0,0,1,.42,1.46l-.4,3.31a1.46,1.46,0,0,0,1,1.5,36.12,36.12,0,0,1,3.67,1.35,4.32,4.32,0,0,0,2.58.17l6.77-2.12a3.61,3.61,0,0,1,3.08.61l4.44,3.7a1.36,1.36,0,0,1-.28,2.4l-5.58,2.8a1.08,1.08,0,0,0-.44,1.48,12.94,12.94,0,0,1,.59,1.57,2.14,2.14,0,0,0,1.51,1.47l7.56,1.29a1.76,1.76,0,0,1,1.41,2.3l-1.21,3.85a2.57,2.57,0,0,1-2.44,1.71l-7.95-.32a3.48,3.48,0,0,0-2.25,1,18.33,18.33,0,0,1-1.95,1.73,1,1,0,0,0-.41.71.86.86,0,0,0,.27.69l3.15,3.36a1.53,1.53,0,0,1,.44,1.36,1.51,1.51,0,0,1-1,1.05l-7,2.78a3.71,3.71,0,0,1-3.13-.32l-4.68-3.11a4,4,0,0,0-2.5-.49c-1.48.25-3,.44-4.55.56a2.61,2.61,0,0,0-1.9,1.24l-1.73,3.37A2.9,2.9,0,0,1,410.74,451.31ZM394.17,440.9a5.16,5.16,0,0,1,2,.36,35.17,35.17,0,0,0,3.59,1.32,2.33,2.33,0,0,1,1.6,2.43l-.4,3.31a1.12,1.12,0,0,0,.23.81,1.08,1.08,0,0,0,.74.4l8.7.91a2,2,0,0,0,1.82-1l1.73-3.38a3.47,3.47,0,0,1,2.61-1.7c1.51-.12,3-.3,4.47-.56a4.94,4.94,0,0,1,3.12.63l4.68,3.11a2.85,2.85,0,0,0,2.33.24l7-2.79a.55.55,0,0,0,.22-1l-3.16-3.36a1.79,1.79,0,0,1-.49-1.36,1.85,1.85,0,0,1,.74-1.32,18.89,18.89,0,0,0,1.86-1.66,4.29,4.29,0,0,1,2.9-1.22l8,.32a1.69,1.69,0,0,0,1.57-1.11l1.21-3.85a.93.93,0,0,0-.07-.77.91.91,0,0,0-.65-.41l-7.57-1.3a3,3,0,0,1-2.19-2.08,10.13,10.13,0,0,0-.55-1.44,2,2,0,0,1,.84-2.62l5.58-2.8a.64.64,0,0,0,.4-.45.63.63,0,0,0-.28-.52l-4.45-3.7a2.75,2.75,0,0,0-2.26-.45L433.16,416a5.27,5.27,0,0,1-3.18-.21,36.07,36.07,0,0,0-3.59-1.32,2.31,2.31,0,0,1-1.6-2.43l.4-3.3A1.13,1.13,0,0,0,425,408a1.08,1.08,0,0,0-.74-.4l-8.7-.91a2,2,0,0,0-1.82,1L412,411a3.53,3.53,0,0,1-2.61,1.71c-1.52.11-3,.3-4.47.55a4.88,4.88,0,0,1-3.12-.63l-4.68-3.11a2.88,2.88,0,0,0-2.33-.24l-7,2.79a.67.67,0,0,0-.45.43.66.66,0,0,0,.23.58l3.15,3.36a1.75,1.75,0,0,1,.5,1.35,1.85,1.85,0,0,1-.74,1.32,18.76,18.76,0,0,0-1.86,1.66,4.3,4.3,0,0,1-2.9,1.23l-8-.33a1.76,1.76,0,0,0-1.58,1.12l-1.2,3.84a.93.93,0,0,0,.07.77,1,1,0,0,0,.65.42l7.57,1.29a3,3,0,0,1,2.19,2.08,9.69,9.69,0,0,0,.55,1.44,1.94,1.94,0,0,1-.84,2.62l-5.59,2.81a.61.61,0,0,0-.39.44.63.63,0,0,0,.28.52l4.45,3.7a2.72,2.72,0,0,0,2.26.45l6.77-2.12A4.12,4.12,0,0,1,394.17,440.9Zm18.93-2.33c-5.38,0-10.68-1.47-14-4.22-2.35-2-3.43-4.34-3.05-6.74.47-3,3.15-5.67,7.35-7.36,7.67-3.06,18.25-1.95,23.58,2.49h0c2.35,1.95,3.43,4.35,3.05,6.74-.47,3-3.15,5.68-7.35,7.36A26.21,26.21,0,0,1,413.1,438.57Zm-.05-19.2a25.31,25.31,0,0,0-9.31,1.69c-3.91,1.56-6.39,4-6.82,6.69-.33,2.08.65,4.19,2.75,5.94C404.79,438,415,439,422.38,436c3.91-1.56,6.39-4,6.82-6.68.32-2.09-.65-4.2-2.75-5.94h0C423.29,420.78,418.22,419.37,413.05,419.37Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.69 381.62 127.59 436.74 277.72 350.33 179.83 295.21 29.69 381.62",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.69 381.62 127.59 436.74 277.72 350.33 179.83 295.21 29.69 381.62",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.65,432.7l-94.6-53.59c2.34-6.67,2.15-9.65-.51-18.52l94,53S129.27,414.46,128.65,432.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,406.36c4.77,2.73,8.65,9.38,8.66,14.86v12.57c0,5.48-3.86,7.7-8.63,5l-93.3-52.84,0-4.3,92.12,51.84c2.87,1.64,5.18.31,5.17-3l-.09-11.3a11.41,11.41,0,0,0-5.2-8.92l-92-51.87v-4.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,406.36c4.77,2.73,8.65,9.38,8.66,14.86v12.57c0,5.48-3.86,7.7-8.63,5l-93.3-52.84,0-4.3,92.12,51.84c2.87,1.64,5.18.31,5.17-3l-.09-11.3a11.41,11.41,0,0,0-5.2-8.92l-92-51.87v-4.87Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.66,353.53l150.13-86.41L273.09,320c4.77,2.73,8.65,9.39,8.66,14.86l0,12.58c0,2.73-1,4.66-2.53,5.56L129.11,439.36c1.57-.91,2.52-2.83,2.53-5.56V421.21c0-5.47-3.88-12.13-8.65-14.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,412.75a17.43,17.43,0,0,1,2.54,8.46V433.8c0,2.73-1,4.65-2.53,5.56L279.24,353c1.57-.9,2.52-2.83,2.53-5.56l0-12.58a17.52,17.52,0,0,0-2.55-8.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,412.75a17.43,17.43,0,0,1,2.54,8.46V433.8c0,2.73-1,4.65-2.53,5.56L279.24,353c1.57-.9,2.52-2.83,2.53-5.56l0-12.58a17.52,17.52,0,0,0-2.55-8.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,337.9c2.81,12.16,2.78,17.87,0,26.79l-7.14,4.14c2.74-8.92,2.77-14.63,0-26.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.46,394.73c2.81,12.15,2.78,17.66,0,26.58l-7.14,4.14c2.74-8.92,2.78-14.47,0-26.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.93,337.9c2.81,12.16,2.78,17.87,0,26.79l-7.14,4.14c2.74-8.92,2.77-14.63,0-26.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.46,394.73c2.81,12.15,2.78,17.66,0,26.58l-7.14,4.14c2.74-8.92,2.78-14.47,0-26.62Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.62,345.05l3.83-2L39,342.17A2.66,2.66,0,0,0,38.62,345.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,345.05l3.83-2L39,342.17A2.66,2.66,0,0,0,38.62,345.05Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,396.12a8.62,8.62,0,0,1-7.79,0L44.85,345.66l144-81.87,3-1.77,87.39,49.23c2.14,1.24,2.14,3.26,0,4.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21,302,76.74,319.57,57,308.18,34.06,321.44v15.31c0,2,2.25,4.86,3.07,4.39a22.67,22.67,0,0,1,4.38,1.56c2.6,1.19,6.34,4.69,6.34,4.69l70-39.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21,302,76.74,319.57,57,308.18,34.06,321.44v15.31c0,2,2.25,4.86,3.07,4.39a22.67,22.67,0,0,1,4.38,1.56c2.6,1.19,6.34,4.69,6.34,4.69l70-39.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65,323.28V339.9l-.26-.16a7.91,7.91,0,0,0-3.74-1.17,3.88,3.88,0,0,0-2.45.58v-19.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.94,345.61a5.09,5.09,0,0,0-1.1-2.83,8.9,8.9,0,0,0-1.07-1.23l-.37-.36-.48-.4-.4-.3c-.29-.21-.58-.4-.87-.58V323.36l4.27,2.47v-.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.06,336.75c0,2,2.25,4.86,3.07,4.39h0l3.06-2V326.51l-3.07-5.28-1.67-.59-1.39.8Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,374.94v19a5.21,5.21,0,0,1-2.6-.61L124,387.77l-73-42.16,0-19.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.09,296.13v14.32a5.75,5.75,0,0,1-2.59,4.49L148.3,387.77l-9.57,5.53a5.19,5.19,0,0,1-2.59.61V377.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,239.14l-144,83.1V324c0,1-1.36,1.33-3,.36s-3.05-2.19-3.05-3.86l-.17-1.67L185,234.31l.54-.31a1.71,1.71,0,0,1,.23.81v.81C185.81,236.59,187.16,238.15,188.84,239.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,239.14l-144,83.1V324c0,1-1.36,1.33-3,.36s-3.05-2.19-3.05-3.86l-.17-1.67L185,234.31l.54-.31a1.71,1.71,0,0,1,.23.81v.81C185.81,236.59,187.16,238.15,188.84,239.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,372.7,46.79,323.36c-1.09-.57-2.08-1-2.5-.81l.56-.31,144-83.1,1.52-.88c.85-.49,2.69-.22,4.13.61l84.79,49c2.14,1.24,2.14,3.26,0,4.49L140,372.7A8.62,8.62,0,0,1,132.24,372.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,234l-.54.31L38.59,318.82a1,1,0,0,0-.28-.36l-.45-.25-1-.56L35.71,317a1.22,1.22,0,0,0-1.51.14.61.61,0,0,0-.15.13,3,3,0,0,0-.4.56,3.45,3.45,0,0,0-.35.75c-.1.27-.19.57-.27.87s-.13.66-.19,1a3.91,3.91,0,0,0-.08.61c0,.17,0,.32,0,.49,0,.38,0,.77,0,1.17V319c0-2.07,1.76-4.75,3.9-6l139.26-80.38c2.16-1.24,5.26-1.45,6.94-.49l1.59.92.06,0a6.1,6.1,0,0,0,.67.39s0,0,0,0A1.35,1.35,0,0,1,185.58,234Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,396.11,127,393.06,47.85,347.38a5.1,5.1,0,0,0-1.08-2.83,11.42,11.42,0,0,0-3.46-3,7.83,7.83,0,0,0-3.73-1.17,4,4,0,0,0-2.46.81,13.62,13.62,0,0,1-1.45-6.55h-3c0,4.13,1.37,8.29,3,9.24l1.52.89c.85.49,1.53.52,1.53.06V344c0-.9,1.36-.86,3.05.12s3,2.49,3,3.38v.81c0,.47,1.17,1.5,2.59,2.33L124,394.8l8.28,4.77s0,0,0,0a8.18,8.18,0,0,0,3.89.91V397A7.89,7.89,0,0,1,132.24,396.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,396.11,127,393.06,47.85,347.38a5.1,5.1,0,0,0-1.08-2.83,11.42,11.42,0,0,0-3.46-3,7.83,7.83,0,0,0-3.73-1.17,4,4,0,0,0-2.46.81,13.62,13.62,0,0,1-1.45-6.55h-3c0,4.13,1.37,8.29,3,9.24l1.52.89c.85.49,1.53.52,1.53.06V344c0-.9,1.36-.86,3.05.12s3,2.49,3,3.38v.81c0,.47,1.17,1.5,2.59,2.33L124,394.8l8.28,4.77s0,0,0,0a8.18,8.18,0,0,0,3.89.91V397A7.89,7.89,0,0,1,132.24,396.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,372.71h0L127,369.64,66.19,334.57l-19.4-11.21c-1.38-.81-2.51-1.09-2.58-.67a0,0,0,0,0,0,0v.89c0,1-1.36,1-3,0s-2.36-2.12-2.39-3.06v-1a1.43,1.43,0,0,0-.45-1.14l-.45-.25-1-.56L35.71,317a1.22,1.22,0,0,0-1.51.14.61.61,0,0,0-.15.13,2.42,2.42,0,0,0-.27.36.69.69,0,0,0-.13.2,3.45,3.45,0,0,0-.35.75c-.1.27-.19.57-.27.87s-.13.66-.19,1a3.91,3.91,0,0,0-.08.61c0,.17,0,.32,0,.49,0,.38,0,.77,0,1.17v11.9h3V322.7c0-.31,0-.63,0-.93l.07-.74a.11.11,0,0,1,0-.08c.27,2.38,2.55,4.51,4.52,5.63A7.51,7.51,0,0,0,44,327.72a4,4,0,0,0,2.68-1l.27.15.52.32L124,371.38l8.28,4.78h0s0,0,.07,0a8,8,0,0,0,3.82.89v-3.46A8.08,8.08,0,0,1,132.27,372.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,372.71h0L127,369.64,66.19,334.57l-19.4-11.21c-1.38-.81-2.51-1.09-2.58-.67a0,0,0,0,0,0,0v.89c0,1-1.36,1-3,0s-2.36-2.12-2.39-3.06v-1a1.43,1.43,0,0,0-.45-1.14l-.45-.25-1-.56L35.71,317a1.22,1.22,0,0,0-1.51.14.61.61,0,0,0-.15.13,2.42,2.42,0,0,0-.27.36.69.69,0,0,0-.13.2,3.45,3.45,0,0,0-.35.75c-.1.27-.19.57-.27.87s-.13.66-.19,1a3.91,3.91,0,0,0-.08.61c0,.17,0,.32,0,.49,0,.38,0,.77,0,1.17v11.9h3V322.7c0-.31,0-.63,0-.93l.07-.74a.11.11,0,0,1,0-.08c.27,2.38,2.55,4.51,4.52,5.63A7.51,7.51,0,0,0,44,327.72a4,4,0,0,0,2.68-1l.27.15.52.32L124,371.38l8.28,4.78h0s0,0,.07,0a8,8,0,0,0,3.82.89v-3.46A8.08,8.08,0,0,1,132.27,372.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,290v3.52a2.68,2.68,0,0,1-1.54,2.22l-.06,0-131,75.58L140,376.16h0a8.17,8.17,0,0,1-3.88.92v-3.46a7.88,7.88,0,0,0,3.89-.93l5.26-3h0l134-77.34A2.65,2.65,0,0,0,280.88,290Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,290v3.52a2.68,2.68,0,0,1-1.54,2.22l-.06,0-131,75.58L140,376.16h0a8.17,8.17,0,0,1-3.88.92v-3.46a7.88,7.88,0,0,0,3.89-.93l5.26-3h0l134-77.34A2.65,2.65,0,0,0,280.88,290Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,313.45V317a2.7,2.7,0,0,1-1.54,2.22l-.06,0-131,75.59L140,399.57v0s0,0,0,0a8.17,8.17,0,0,1-3.88.91V397a7.88,7.88,0,0,0,3.89-.93l5.26-3h0l134-77.33A2.66,2.66,0,0,0,280.88,313.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,313.45V317a2.7,2.7,0,0,1-1.54,2.22l-.06,0-131,75.59L140,399.57v0s0,0,0,0a8.17,8.17,0,0,1-3.88.91V397a7.88,7.88,0,0,0,3.89-.93l5.26-3h0l134-77.33A2.66,2.66,0,0,0,280.88,313.45Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24.17 314.53 125.69 372.36 260.69 294.88 159.19 237.05 24.17 314.53",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.17 314.53 125.69 372.36 260.69 294.88 159.19 237.05 24.17 314.53",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62,368.82,28,312.34q3.09-8.76-.42-20.44l98.12,56S127.18,352.83,126.62,368.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,341.51a16.63,16.63,0,0,1,7.57,13v15.23c0,4.8-3.39,6.75-7.58,4.35L24.18,318.31v-3.78l96.45,55c2.51,1.44,4.54.27,4.54-2.61l-.07-14.11a10,10,0,0,0-4.55-7.83L24.18,290v-4.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,341.51a16.63,16.63,0,0,1,7.57,13v15.23c0,4.8-3.39,6.75-7.58,4.35L24.18,318.31v-3.78l96.45,55c2.51,1.44,4.54.27,4.54-2.61l-.07-14.11a10,10,0,0,0-4.55-7.83L24.18,290v-4.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,285.69l135-77.48L256.67,264a16.63,16.63,0,0,1,7.57,13v15.24c0,2.39-.84,4.08-2.22,4.87L127,374.66c1.38-.79,2.22-2.48,2.23-4.87V354.54a16.65,16.65,0,0,0-7.58-13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,285.69l135-77.48L256.67,264a16.63,16.63,0,0,1,7.57,13v15.24c0,2.39-.84,4.08-2.22,4.87L127,374.66c1.38-.79,2.22-2.48,2.23-4.87V354.54a16.65,16.65,0,0,0-7.58-13Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,347.12a15.33,15.33,0,0,1,2.22,7.42v15.25c0,2.39-.85,4.08-2.23,4.87l135-77.48c1.38-.79,2.22-2.48,2.22-4.87V277.07a15.33,15.33,0,0,0-2.22-7.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,347.12a15.33,15.33,0,0,1,2.22,7.42v15.25c0,2.39-.85,4.08-2.23,4.87l135-77.48c1.38-.79,2.22-2.48,2.22-4.87V277.07a15.33,15.33,0,0,0-2.22-7.42Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23,279.76c2.45,10.66,2.42,19.87,0,27.69L238,311.07c2.42-7.82,2.46-17,0-27.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.55,331.53c2.46,10.66,2.42,19.87,0,27.7l-6.28,3.62c2.42-7.82,2.46-17,0-27.7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,348s-10.92,16.7-13,23.73c-2.14,7.32-4.54,9.36-5.14,17.71-.13,1.82,0,5.55-.11,7a2.19,2.19,0,0,1-2.56,2.19c-3.45-.07-7.5-7.33-8.56-14.49s-1.27-22.8-1.09-24.63a10.3,10.3,0,0,1,2.26-5,15.62,15.62,0,0,1,2.14-2.34c1.84-3,3.8-9,5.7-13Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,364.88a7.78,7.78,0,0,0-1.44,2.23c-.43,1.46,1.85,7.09,2.77,9.16s1.71,4.59.49,9c-1.3,4.69-.23,9.72,2,14.32s6.64,10.09,14,14.28,11.15.91,11.15.91,3.36-3.22,2.23-5.09S154.6,364.88,154.6,364.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,352.26c-.24-.07-.66-.23-1.45.37-.31.22-2.58,3.41-4.22,5s-5.63,4.36-6.74,7.27c.5,6.2,5.11,11.47,4.66,17.12s-1.83,12,5.19,20.62,15.68,11.27,19.27,10.21,4.07-4.45,1.13-11.77C181.73,393.29,182,378,182,378a48.53,48.53,0,0,1,.61-6.37c.31-2,1.4-4,2-6a4.59,4.59,0,0,0,.25-2.87,4.89,4.89,0,0,0-2-2.12,21.05,21.05,0,0,0-4.07-2.45,7.37,7.37,0,0,0-4.67-.48c-1.11.3-2.11.95-3.25,1.14a4.21,4.21,0,0,1-4-1.68,3.44,3.44,0,0,1-.26-4.05S167,352.26,167,352.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.69,396.13s4.87-5.87,14-3.79,11.2,7.31,12,10.29c.91,3.55,1.28,9.69-2.87,10.5-4.48.88-9.06-.73-15.61-6S160.69,396.13,160.69,396.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.63,369.65a1,1,0,0,0,.83.18c1.57-.39,9.38-.24,12.8,4.67.66-.32.74-1.15.28-2.45-4.34-4.29-11.72-4.46-13.62-4a.87.87,0,0,0-.63,1.11A1,1,0,0,0,168.63,369.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,379.9a2.78,2.78,0,0,0,.05-2.57c-4.39-3.78-11.25-3.91-13.07-3.47a.87.87,0,0,0-.63,1.11,1,1,0,0,0,.33.48,1,1,0,0,0,.83.19C171,375.26,178.42,375.4,182,379.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.88,392.78a5.13,5.13,0,0,0-.41-3.49c-4.36-4.11-11.57-4.28-13.45-3.81a.86.86,0,0,0-.63,1.1.93.93,0,0,0,.34.48,1,1,0,0,0,.83.19C171.22,386.84,179.82,387,182.88,392.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.69,381.26a1,1,0,0,0,.84.18c1.55-.38,9.2-.24,12.67,4.51a3.16,3.16,0,0,0-.14-2.81c-4.39-3.78-11.25-3.92-13.07-3.47a.87.87,0,0,0-.63,1.11A1,1,0,0,0,168.69,381.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,374.93s-.3,17.28-.43,30.62c-.09,9.71,6.92,14.56,12.53,21.34,1.22,1.48,4,4.24,5,5.43a2.23,2.23,0,0,1-.36,3.47c-2.69,2.37-13.74,2.65-19.76-2.05s-11.3-14.52-14.85-18.27c-1.34-1.41-2.59-2.85-3.78-4.37s-.76-2.83-.81-4.44c0-.78.16-2.9.16-2.9-.7-3.82-2.8-15.52-3.89-19.25Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,420.75a8.1,8.1,0,0,0,.18,2.77c.56,1.48,6,4.83,8.12,6s4.34,2.81,6.08,7.24c1.86,4.74,5.94,8.32,10.7,10.84A36.24,36.24,0,0,0,218,451c8.91-1,10-6,10-6s.81-4.75-1.32-5.64S172.05,420.75,172.05,420.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,402.57c-.24.09-.69.21-1,1.2-.11.37,0,4.44-.42,6.77s-2,7.1-1.1,10.21c4.32,4.92,11.54,6.53,14.72,11.55s6,11.22,17.39,14.17,20.35-.1,22.71-3.18.63-6.23-6.47-10.59c-7.53-4.63-17-17.61-17-17.62a50.83,50.83,0,0,1-3.5-5.74c-1-1.89-1.36-4.24-2.07-6.28a4.79,4.79,0,0,0-1.6-2.56,5.28,5.28,0,0,0-3-.57,22.4,22.4,0,0,0-5,.43,7.61,7.61,0,0,0-4.25,2.45,35.62,35.62,0,0,1-2,2.94,4.47,4.47,0,0,1-4.47,1.06,3.65,3.65,0,0,1-2.77-3.25A9.65,9.65,0,0,1,174.56,402.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,443.32s.41-7.91,9.41-11.73,14.07-.69,16.59,1.35c3,2.42,7.2,7.36,4.21,10.58-3.24,3.47-8.11,4.92-17,4.48S196.89,443.32,196.89,443.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,416.2a1,1,0,0,0,.81-.35c1.09-1.29,7.77-5.94,13.75-3.9.36-.67-.1-1.41-1.3-2.22-6.37-1-12.71,3.4-14,5a.9.9,0,0,0,.17,1.31A1,1,0,0,0,186.9,416.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63,416.67a2.93,2.93,0,0,0-1.57-2.19c-6.09-.5-12,3.58-13.23,5.07a.89.89,0,0,0,.17,1.31,1,1,0,0,0,.58.2,1,1,0,0,0,.82-.35C192.46,419.46,198.8,415.06,204.63,416.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,427a5.44,5.44,0,0,0-2.55-2.68c-6.28-.8-12.47,3.47-13.76,5a.89.89,0,0,0,.17,1.31,1,1,0,0,0,.58.2,1,1,0,0,0,.82-.35C199.92,429.07,207.3,424,213.52,427Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,425.92a1,1,0,0,0,.82-.35c1.07-1.27,7.62-5.82,13.55-3.95a3.35,3.35,0,0,0-1.9-2.28c-6.09-.5-12,3.58-13.22,5.07a.89.89,0,0,0,.17,1.31A1,1,0,0,0,194.27,425.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,241s39.25,22.08,54.86,40.53c5.59,6.6,9,12.29,1.61,27.95-5.65,12.06-14.91,25.16-23.7,40.68l-68.23-92.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,241s39.25,22.08,54.86,40.53c5.59,6.6,9,12.29,1.61,27.95-5.65,12.06-14.91,25.16-23.7,40.68l-68.23-92.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,348c-10.81-11.18-43.06-73.26-43.06-73.26l1.66-.16c9.2-3.31,13.67-15.18,13.67-15.18.76,4.91-1.68,11.67-4.92,15.17,4.8,4,15.64,13.17,32.29,27.45,2.9,2.49,8.77,7.22,7.82,15.71-1.24,11.09-2.32,22-2.32,22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,241h0l-75.72,6.56c.84,8.95.66,22.46,6.62,32.78,8.27,14.3,14.06,19.22,31.83,27.82s34.8,15.85,38.64,18.26c2.88,1.81,1.88,8.49,2.26,16.45.4,8.36,1,13,4.35,31,1.64,8.76,3.43,16.34,3.43,16.34s14.38,2.57,25.54-2.49c0,0,1.16-43.67,1.3-54.39.13-9.16,1.3-17.61-5.22-24.89-5.6-6.24-40.53-33.83-40.53-33.83S165.52,257.71,160.37,241Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,247.27l1-.08c-.4,12,.65,21.27,8.72,30.69,5.76-3.35,4.86-6.88,3.21-13.19-.5-1.9-1.06-4.05-1.5-6.47a63.84,63.84,0,0,1-1.12-11.81l1-.08A61.1,61.1,0,0,0,113,258c.43,2.38,1,4.51,1.48,6.4,1.64,6.29,2.72,10.5-3.51,14.22a58.91,58.91,0,0,0,6.64,6.26c12.3,10.06,29.82,22.08,40.29,29.26,3.65,2.51,6.54,4.49,8,5.58,6.05,4.43,6.06,6.83,5.14,17.41-.82,9.27,3.48,40.68,5.89,53.57l-1-.07c-2.43-13.15-6.68-44.32-5.87-53.59.94-10.71.72-12.52-4.72-16.5-1.47-1.08-4.36-3.06-8-5.56-10.48-7.19-28-19.22-40.36-29.31C101.81,273.35,100,262.53,100.51,247.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.52,214.39a295,295,0,0,1-16.27-27.81l-2.17-34.23s10.19.06,16.84,11.84c5.51,9.77,9.5,17.61,16.1,30.54,0,0,13.52-14,15.29-16.53a30.43,30.43,0,0,0,3.23-6.41c2.42-6.19,6.29-9.28,11.35-13.36.86-.7,1.74-1.39,2.61-2.08a12.44,12.44,0,0,0,1.25-1c.35-.37.67-.66,1.24-.36a1.89,1.89,0,0,1,.8,1.07,5.42,5.42,0,0,1-.63,4.35,26.3,26.3,0,0,1-2.74,3.6c-.73.9.59,1,1.22.89,3.07-.33,7-3.32,9.38-5.15,1.59-1.2,2.95-2.7,4.72-3.66a6.1,6.1,0,0,1,3.55-.82c.84.09,1.57.46,1.35,1.49a4.26,4.26,0,0,1-1,1.65c-.84,1.05-1.58,2-1.44,3.42a10.06,10.06,0,0,1,.23,2.67c-.18,1.13-1,2.06-1.29,3.17a26,26,0,0,0-.1,2.91,8.55,8.55,0,0,1-1.82,3,27.67,27.67,0,0,1-5.1,5.1,52.81,52.81,0,0,1-9.41,5.61,19.22,19.22,0,0,0-5.66,5.06c-1.39,2-4.83,8.4-5.82,10.23-1.22,2.25-8.67,17.38-16.76,23.49C181.24,227,175.65,226.21,167.52,214.39Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,194.73c-3.59,3.35-7,9.74-6.85,13.54-.71-4.08.92-10.12,6-15.27Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,151c16.53,1.45,20.05,7.28,26.28,18.1,3.62,6.28,10.62,20.69,10.62,20.69s-2.34,6.86-7.89,11.11a17.31,17.31,0,0,1-11.59,3.51l-9.72-17.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,169.07c.41,4-.14,7.93-3.82,11.71,0,0,3.05-.09,4.36-4.59C215,172.15,214.05,170.38,213.23,169.07Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,182.22c-.75-21.28-9.54-30-20.31-31.35a81.54,81.54,0,0,0-22.82.45c-14,2.22-17.44,4.37-23.61,6.41-4.2,1.9-10.74,11.91-11.66,26.91-.66,10.65-2.43,24.2-1.17,43.1.82,12.32,1,21.72,3,37.92,14.65,5.8,63.23.24,76-24.34-1.31-3.73-1.62-16.36-1.41-23.51S162.63,188.91,162.39,182.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.57,142.89c-.29-6-5.41-12.87-7.43-18.33-2-5.26-3-9.29-2.14-13.92.5-2.73,2.69-6.26,4.83-6.8C111.71,93.3,120,89.47,124.18,89A42.81,42.81,0,0,0,130,88.1c2.33-.66,3.05-2.39,5-3.69,3.4-2.25,8.6-1.68,10.1,2.53,2.37-2.41,5.15-2,8.27-.8a5.53,5.53,0,0,1,3.45,6.72c4.6-1.89,8.17,1.63,8.26,4.21.07,1.9-.52,3.42.5,5.24,1.15,2,3.75,2.33,4.72.91.13,2.7-1.15,4.6-4,4.1a6.06,6.06,0,0,1,.14,5.15,5.54,5.54,0,0,1-5.43,3.19c-.48,1.41-.7,2.74-1.76,3.88a9.54,9.54,0,0,1-3.76,2.64c-4.6,1.55-9.49,1.64-14.3,2l-5.7.48c-.33,0-2-.07-2.26.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,134.41c3.84,3,7,.63,7,.63l-2.66,19.41c2.23,8.71,16.27,11.83,21.73,10.1s5.17-4.87,2.38-9.94l.74-3.13a56,56,0,0,0,7,.53c4.7-.07,8.63-3.4,10.55-8.24a52.4,52.4,0,0,0,3-19.77,17.77,17.77,0,0,1,.34-4.88c1-4.25.5-6.84-.18-10.59-4.59-4.71-16.18-7.53-27.95-2.19.47,6.68-2.69,11.54-7.74,13.46,0,1.79-.31,6.26-3.2,5.83-2.08-.31-1.9-2.95-3.76-5.51s-6.79-3.79-9.14-.63C106.18,123.92,107.14,131.15,111.35,134.41Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,117.12l-14.35,2.12a5.63,5.63,0,0,1,1.74,2.48L132,120.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,117.18c-3.19-.43-7.53-.62-10.18.17-3,.91-4.07,1.93-5.71,1.93s-2.82-1-5.93-2c-2.77-.79-7.46-.62-10.9-.21a1.74,1.74,0,0,0-1.23,1.67c0,1.39.93,1.62,1.09,2.75.37,4.27.73,9.12,6.32,9.36,10.14.38,7.14-9.73,10.89-9.08,1.39.33,1.12,3,1.93,5a8.16,8.16,0,0,0,1.28,2.15,6.28,6.28,0,0,0,5,2,5.92,5.92,0,0,0,5.93-3.85,35.4,35.4,0,0,0,1.24-5.48c.32-1,1.12-1.32,1.24-2.7A1.63,1.63,0,0,0,164.9,117.18Zm-19.84,7.62a6.65,6.65,0,0,1-1.58,2.91h0c-2.41,2.63-8.5,2.23-9.43-1.75h0a5.68,5.68,0,0,1-.17-.61v0c-.36-1.65-.79-5.1.13-6.08,1.62-1.6,9-1.39,11.18,1.18C145.75,121.32,145.48,123.19,145.06,124.8Zm17.89-.58c-.25,1.13-.8,3.59-3,4.67-2.18,1.25-6.15.13-6.87-1.71-1.06-1.78-1.44-5.25-.6-6.73.6-.87,2.87-1.83,5-2.09,1.85-.19,4-.24,5.5,1C163.68,120,163.27,122.77,163,124.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.41,132.18,148,135,147,124.14c.5-1.47,1-2.54,2.26-2.33.09.11.2.21.29.32.25.29.51.6.78,1,.43.61.87,1.31,1.32,2.06.65,1.09,1.33,2.3,2,3.54.3.57.58,1.13.88,1.69.07.14.14.28.22.41C154.91,131.26,155.18,131.72,155.41,132.18Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.52,151.48c-7.22-1.76-12.7-3.23-15.87-9a46.43,46.43,0,0,1-3.37-9.23s0,6.59,1.83,11.27c1.43,3.62,5.43,7.14,16.8,9.52Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31,123.93a2.08,2.08,0,1,1-4.14-.32,2.1,2.1,0,0,1,2.22-2A2.13,2.13,0,0,1,141.31,123.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25,114.31l-4.95,1.1a2.66,2.66,0,0,1,2-3.1A2.47,2.47,0,0,1,141.25,114.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,135.85l6.61,2.87a3.78,3.78,0,0,1-4.87,1.91A3.52,3.52,0,0,1,139,135.85Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.66,140.87a4.26,4.26,0,0,0-4-4,3.47,3.47,0,0,0,2,3.79A3.63,3.63,0,0,0,142.66,140.87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,116.42l-5-1.18a2.46,2.46,0,0,1,3-1.94A2.69,2.69,0,0,1,159.91,116.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,124.3a2.11,2.11,0,0,1-2.39,1.79,2.16,2.16,0,1,1,2.39-1.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M171,255.66,135.75,276c-.52.3-.56.81-.07,1.13l43.76,29.33a1.86,1.86,0,0,0,1.83,0l35.2-20.31c.53-.31.56-.81.07-1.14L172.78,255.7A1.91,1.91,0,0,0,171,255.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.75,256.86l-33.26,17.5-.73,1.11-.06.9a1.28,1.28,0,0,0,.59,1.14l40.65,27.31a2,2,0,0,0,1.08.32,2.09,2.09,0,0,0,1.12-.27L213.77,286l.06-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,304.24a2.05,2.05,0,0,1-1.09-.32L138.35,276.6a1.23,1.23,0,0,1-.59-1.13,1.38,1.38,0,0,1,.73-1.11L170.39,256l43.44,29.18L181.2,304A2.21,2.21,0,0,1,180.08,304.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.56,253.3,139,271.51l-.35.46-.22,3.51h0a.54.54,0,0,0,.28.48l40.65,27.32a1.56,1.56,0,0,0,1.51,0l31.54-18.21.23-3.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.66,281.59l-.4.23-5.13,3-1,.56-25,14.46a1.58,1.58,0,0,1-1.51,0L139,272.45a.51.51,0,0,1,0-.94l.42-.24,31.13-18,41.74,28.05.08.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.35,300l-.22,3.51a1.27,1.27,0,0,1-.74-.21L138.73,276a.55.55,0,0,1-.28-.48l.23-3.51a.53.53,0,0,0,.28.48l40.65,27.32A1.46,1.46,0,0,0,180.35,300Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,281.12,207,284.4l-.89.51-25,14.42a1.54,1.54,0,0,1-1.5,0l-36.41-24.47c-.32-.21-.63-.41-.91-.61a9.2,9.2,0,0,1-2.89-3l-.06-.13a.75.75,0,0,1-.08-.24.78.78,0,0,1,.58-.82,13.68,13.68,0,0,0,2.94-1.22l0,0,27.74-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,280.58c-.41.24-.43.63-.06.88a1.44,1.44,0,0,0,1.41,0,.48.48,0,0,0,.05-.88A1.45,1.45,0,0,0,207.06,280.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.76,277.84a1.74,1.74,0,0,0-1.9.1,6.73,6.73,0,0,0-2.62,3.64,1.49,1.49,0,0,0,.52.08,6,6,0,0,1,2.33-3.23,1.67,1.67,0,0,1,.88-.26.89.89,0,0,1,.5.15,2.09,2.09,0,0,1,.59,1.9c0,.15,0,.3-.05.45l.47.32a5.11,5.11,0,0,0,.1-.76A2.6,2.6,0,0,0,211.76,277.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.42,281.28a.93.93,0,0,1,0,.13l-.08-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,277.84a.48.48,0,0,0,0,.88,1.4,1.4,0,0,0,1.4,0,.48.48,0,0,0,.06-.88A1.47,1.47,0,0,0,203,277.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.68,275.1a1.74,1.74,0,0,0-1.9.1,6.77,6.77,0,0,0-2.61,3.64,1.22,1.22,0,0,0,.51.08,6.14,6.14,0,0,1,2.33-3.23,1.72,1.72,0,0,1,.88-.26.84.84,0,0,1,.5.15,2.1,2.1,0,0,1,.6,1.9,3.47,3.47,0,0,1-.06.45l.48.32a6.89,6.89,0,0,0,.1-.76A2.58,2.58,0,0,0,207.68,275.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,275.1c-.4.24-.43.63-.06.88a1.44,1.44,0,0,0,1.41,0c.41-.24.43-.63.06-.88A1.44,1.44,0,0,0,198.91,275.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.61,272.36a1.74,1.74,0,0,0-1.9.1,6.73,6.73,0,0,0-2.62,3.64,1.29,1.29,0,0,0,.52.08,6,6,0,0,1,2.33-3.23,1.69,1.69,0,0,1,.88-.26,1,1,0,0,1,.5.15,2.1,2.1,0,0,1,.59,1.9,3.44,3.44,0,0,1,0,.45l.47.32a4.07,4.07,0,0,0,.1-.76A2.58,2.58,0,0,0,203.61,272.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,272.37a.48.48,0,0,0-.05.88,1.47,1.47,0,0,0,1.41,0,.48.48,0,0,0,.05-.88A1.44,1.44,0,0,0,194.83,272.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54,269.62a1.8,1.8,0,0,0-1.91.1,6.77,6.77,0,0,0-2.61,3.64,1.27,1.27,0,0,0,.51.08,6.11,6.11,0,0,1,2.33-3.22,1.85,1.85,0,0,1,.89-.27.92.92,0,0,1,.49.16,2.05,2.05,0,0,1,.6,1.89c0,.15,0,.3-.05.45l.47.32a6.59,6.59,0,0,0,.1-.76A2.61,2.61,0,0,0,199.54,269.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,269.63a.48.48,0,0,0-.06.88,1.44,1.44,0,0,0,1.41,0,.48.48,0,0,0,.06-.88A1.47,1.47,0,0,0,190.76,269.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.46,266.89a1.74,1.74,0,0,0-1.9.1,6.68,6.68,0,0,0-2.61,3.64,1.4,1.4,0,0,0,.51.08,6,6,0,0,1,2.33-3.23,1.84,1.84,0,0,1,.88-.27,1,1,0,0,1,.5.16,2.11,2.11,0,0,1,.6,1.9,3.47,3.47,0,0,1-.06.45l.48.31a6.42,6.42,0,0,0,.1-.75A2.58,2.58,0,0,0,195.46,266.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69,266.89c-.41.24-.43.63-.06.88a1.44,1.44,0,0,0,1.41,0,.48.48,0,0,0,.05-.88A1.45,1.45,0,0,0,186.69,266.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39,264.15a1.74,1.74,0,0,0-1.9.1,6.73,6.73,0,0,0-2.62,3.64,1.49,1.49,0,0,0,.52.08,6,6,0,0,1,2.32-3.23,1.72,1.72,0,0,1,.89-.26.89.89,0,0,1,.5.15,2.09,2.09,0,0,1,.59,1.9c0,.15,0,.3-.05.45l.47.32a5.11,5.11,0,0,0,.1-.76A2.6,2.6,0,0,0,191.39,264.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,264.15a.48.48,0,0,0-.05.88,1.42,1.42,0,0,0,1.4,0c.41-.24.43-.63.06-.88A1.44,1.44,0,0,0,182.61,264.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,261.41a1.74,1.74,0,0,0-1.9.1,6.77,6.77,0,0,0-2.61,3.64,1.22,1.22,0,0,0,.51.08,6.09,6.09,0,0,1,2.33-3.23,1.72,1.72,0,0,1,.88-.26.87.87,0,0,1,.5.15,2.1,2.1,0,0,1,.6,1.9,3.47,3.47,0,0,1-.06.45l.48.32a6.89,6.89,0,0,0,.1-.76A2.58,2.58,0,0,0,187.31,261.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,261.42a.48.48,0,0,0-.06.88,1.47,1.47,0,0,0,1.41,0c.4-.24.43-.63.05-.88A1.42,1.42,0,0,0,178.54,261.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,258.67a1.76,1.76,0,0,0-1.9.1,6.73,6.73,0,0,0-2.62,3.64,1.29,1.29,0,0,0,.52.08,6,6,0,0,1,2.33-3.22,1.62,1.62,0,0,1,.88-.27,1,1,0,0,1,.5.15,2.11,2.11,0,0,1,.59,1.9,3.44,3.44,0,0,1,0,.45l.47.32a5,5,0,0,0,.1-.76A2.6,2.6,0,0,0,183.24,258.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,258.68a.48.48,0,0,0-.05.88,1.47,1.47,0,0,0,1.41,0,.48.48,0,0,0,.05-.88A1.44,1.44,0,0,0,174.46,258.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.17,255.93a1.8,1.8,0,0,0-1.91.1,6.77,6.77,0,0,0-2.61,3.64,1.27,1.27,0,0,0,.51.08,6.11,6.11,0,0,1,2.33-3.22,1.84,1.84,0,0,1,.88-.27.93.93,0,0,1,.5.16,2.05,2.05,0,0,1,.6,1.89c0,.15,0,.3-.05.45l.47.32a6.59,6.59,0,0,0,.1-.76A2.61,2.61,0,0,0,179.17,255.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,255.94a.48.48,0,0,0-.06.88,1.44,1.44,0,0,0,1.41,0,.48.48,0,0,0,.06-.88A1.47,1.47,0,0,0,170.39,255.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.09,253.2a1.74,1.74,0,0,0-1.9.1,6.75,6.75,0,0,0-2.62,3.64,1.49,1.49,0,0,0,.52.08,6,6,0,0,1,2.33-3.23,1.84,1.84,0,0,1,.88-.27,1,1,0,0,1,.5.16,2.09,2.09,0,0,1,.59,1.9,3.44,3.44,0,0,1,0,.45l.48.31a6.42,6.42,0,0,0,.1-.75A2.58,2.58,0,0,0,175.09,253.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,294.51a.44.44,0,0,1-.4-.27.55.55,0,0,1,.22-.7l24.26-14a.45.45,0,0,1,.64.2.55.55,0,0,1-.21.7l-24.27,14A.44.44,0,0,1,176.45,294.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,292.68a.46.46,0,0,1-.4-.26.57.57,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.2.56.56,0,0,1-.22.7l-24.27,14A.41.41,0,0,1,173.73,292.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,290.86a.44.44,0,0,1-.39-.27.55.55,0,0,1,.22-.7l24.26-14a.44.44,0,0,1,.64.2.54.54,0,0,1-.22.7l-24.26,14A.45.45,0,0,1,171,290.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,289a.45.45,0,0,1-.4-.26.54.54,0,0,1,.22-.7l24.26-14a.47.47,0,0,1,.65.21.57.57,0,0,1-.22.7l-24.27,14A.43.43,0,0,1,168.3,289Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.58,287.21a.47.47,0,0,1-.4-.27.57.57,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.2.54.54,0,0,1-.22.7l-24.27,14A.42.42,0,0,1,165.58,287.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.87,285.38a.44.44,0,0,1-.4-.27.55.55,0,0,1,.22-.7l24.26-14a.45.45,0,0,1,.64.21.55.55,0,0,1-.22.7l-24.26,14A.53.53,0,0,1,162.87,285.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.15,283.56a.46.46,0,0,1-.4-.27.55.55,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.2.57.57,0,0,1-.22.7l-24.27,14A.44.44,0,0,1,160.15,283.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,281.73a.45.45,0,0,1-.4-.27.57.57,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.21.55.55,0,0,1-.22.7l-24.26,14A.57.57,0,0,1,157.43,281.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,279.91a.48.48,0,0,1-.4-.27.54.54,0,0,1,.22-.7l24.26-14a.45.45,0,0,1,.65.2.57.57,0,0,1-.22.7l-24.27,14A.44.44,0,0,1,154.72,279.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,278.08a.45.45,0,0,1-.4-.27.56.56,0,0,1,.22-.7l24.27-14a.46.46,0,0,1,.64.21.56.56,0,0,1-.22.7l-24.27,14A.5.5,0,0,1,152,278.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,276.26a.44.44,0,0,1-.39-.27.55.55,0,0,1,.21-.7l24.27-14a.44.44,0,0,1,.64.2.55.55,0,0,1-.22.7l-24.26,14A.47.47,0,0,1,149.28,276.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57,274.43a.44.44,0,0,1-.4-.27.55.55,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.2.58.58,0,0,1-.22.71l-24.27,14A.53.53,0,0,1,146.57,274.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.85,272.61a.49.49,0,0,1-.4-.27.57.57,0,0,1,.22-.7l24.27-14a.45.45,0,0,1,.64.2.55.55,0,0,1-.22.7l-24.27,14A.42.42,0,0,1,143.85,272.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,296.34a.46.46,0,0,1-.4-.27.55.55,0,0,1,.22-.7l25.67-14.85a.45.45,0,0,1,.64.2.57.57,0,0,1-.22.7l-25.67,14.85A.44.44,0,0,1,179.21,296.34Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.33,261.3l2.61,7.34a.24.24,0,0,1-.35.28L153,264.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.59,268.92a.24.24,0,0,0,.35-.28l-.51-1.43h0a1.3,1.3,0,0,1-1.11.79h-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.65,238.88l.45.57.54.68L153,264.66a3.42,3.42,0,0,0,2.47-.59,3.56,3.56,0,0,0,1.84-2.76L138,236.8l-1-1.31C137.55,236.37,133.29,239.76,132.65,238.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,241l1,1.27c.28.38,1.24,0,2.21-.64,1.28-.83,2.43-2.27,2.06-2.77l-.74-.93-.27-.33c.37.5-.78,1.94-2.06,2.78-.92.6-1.85,1-2.17.67h0S134.36,241.05,134.35,241Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,241.35c.64.88,4.91-2.53,4.27-3.4l-1-1.27c.64.87-3.62,4.28-4.27,3.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.65,238.88l1,1.25c.62.86,4.77-2.39,4.32-3.33,0,0,0,0,0-.06l-1-1.25C137.55,236.37,133.29,239.76,132.65,238.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,268.92l.09-.28-3.82-5-20.5-25.93c.08-.06.08-.11,0-.13-1.14,1-2.63,1.83-3,1.34l.45.57.54.68L153,264.66h0l6.57,4.26A.22.22,0,0,0,159.85,268.92Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,233.58l4.17,5.3c.27.38,1.23,0,2.19-.62,1.29-.83,2.45-2.26,2.09-2.77h0l-4.2-5.32c-.83-1-3.18.38-4.11,1.83A1.39,1.39,0,0,0,128.48,233.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32,233.66a4.22,4.22,0,0,0,2.51-2.79,1,1,0,0,0-.24-.85c-.94-.75-3.09.61-4,2a1.4,1.4,0,0,0-.16,1.55C128.78,234,129.47,234,130.32,233.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,244.93c2,.21,2.9,1.15,4,2.54s3.1,2.28,3,3-1.45,1.45-1.45,1.45Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.53,266.1a14,14,0,0,0,8.64-1.4c.65-.36,1.82-1.72,2.46-2.09a4.19,4.19,0,0,1,1.61-.76c.48-.07,1-.07,1.42-.16a3.73,3.73,0,0,0,2.64-2.05,4.48,4.48,0,0,1,.31-.62.82.82,0,0,1,.55-.4,1.25,1.25,0,0,1,.7.17,10.56,10.56,0,0,0,2.5,1.06,5.33,5.33,0,0,0,2,0c.5-.11,1.54-.62,1-1.28-.72-.88-1.4-1.8-2-2.41-3.19-3.19-6.27-4.69-10.36-6.58-1.89-.87-4.62-1.85-6.52-2.68-.81-.35-1.63-.84-2.47-1.25l-2.68-3.39a4.92,4.92,0,0,0-2.08.35,18.36,18.36,0,0,1-4.8,1.07c-3.53.24-10.24-3.05-15.78-5.84s-18-9.53-18-9.53l7-35.92c2.18-14.25.46-27.23-6.16-34.06-3.94.76-10.14,3.89-13.18,7.88s-5.32,10.67-7.11,19.32c-2.48,12-5.87,29.92-7.51,43.27-1.51,12.34,1.13,14.93,10.72,19.23,6.05,2.72,30.74,8.71,40.7,11.66C122.27,260.64,132.12,265.65,135.53,266.1Z",
    style: {
      fill: "#c8856a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.65,157.73c-6.81,2.45-9.87,4.13-12.45,6.69-4.76,4.71-5.62,9.67-7.1,14.54s-6,31.32-6,31.32,2.34,4.75,12.72,7.8c9.07,2.67,14.43,0,14.43,0s3.78-20.39,4.72-25C103.6,185.09,104.84,167,95.65,157.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,228.35a31.23,31.23,0,0,0-9.41-3.44,35.09,35.09,0,0,1,9.83,1.31Z",
    style: {
      fill: "#af6152"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,438.53c-9.08-9.37-14.41-33-5.55-40.48H83.55c8.85,7.43,3.52,31.09-5.55,40.47l-.25.26-.31.31c-.26.25-.53.49-.83.73l-.21.18c-.23.17-.44.35-.69.52a12.9,12.9,0,0,1-1.17.76c-7.47,4.36-19.58,4.36-27.05,0h0a13.18,13.18,0,0,1-1.18-.77c-.22-.15-.43-.32-.64-.48l-.26-.22c-.29-.23-.55-.47-.8-.71l-.36-.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63,395.05c10.29,6,10.28,15.74,0,21.74s-26.95,6-37.24,0-10.28-15.73,0-21.74S69.35,389.05,79.63,395.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,397.94c7.55,4.41,7.55,11.56,0,16s-19.8,4.41-27.35,0-7.55-11.56,0-16S67.13,393.53,74.69,397.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.34,405.52c7.55-4.41,19.79-4.41,27.35,0a12.58,12.58,0,0,1,4.52,4.19,12.69,12.69,0,0,1-4.52,4.2c-7.56,4.41-19.8,4.41-27.35,0a12.72,12.72,0,0,1-4.53-4.2A12.62,12.62,0,0,1,47.34,405.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,362.19c-3,3.85-12.18,5.54-16.73-3.88-4.28-8.83-8.8-17.16-10.15-20.42a3.44,3.44,0,0,1,1.86-4.61s-.12-5,8.62-2.28,15.11,7.43,19.43,15.47S60.43,360.64,54.84,362.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.84,362.19c-3,3.85-12.18,5.54-16.73-3.88-4.28-8.83-8.8-17.16-10.15-20.42a3.44,3.44,0,0,1,1.86-4.61s-.12-5,8.62-2.28,15.11,7.43,19.43,15.47S60.43,360.64,54.84,362.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.49,374.75a44.78,44.78,0,0,0-1.12-5,70.2,70.2,0,0,0-3.56-9.55,72.28,72.28,0,0,0-11.2-17.39,62.22,62.22,0,0,0-8.39-8.16c-.09-.08-.15.12-.08.18A77.26,77.26,0,0,1,48.5,350.6,78.25,78.25,0,0,1,56.94,369c.56,1.82,1.1,3.64,1.58,5.47s.83,3.76,1.29,5.63c0,.19.35.28.34,0A34.83,34.83,0,0,0,59.49,374.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.49,374.75a44.78,44.78,0,0,0-1.12-5,70.2,70.2,0,0,0-3.56-9.55,72.28,72.28,0,0,0-11.2-17.39,62.22,62.22,0,0,0-8.39-8.16c-.09-.08-.15.12-.08.18A77.26,77.26,0,0,1,48.5,350.6,78.25,78.25,0,0,1,56.94,369c.56,1.82,1.1,3.64,1.58,5.47s.83,3.76,1.29,5.63c0,.19.35.28.34,0A34.83,34.83,0,0,0,59.49,374.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.75,355.45C56.82,357.9,50.93,351.71,53,342s12.24-20.48,16.09-17.59c2.4-2.4,7.7-1.54,10.2,6.34S79.48,358.89,64.75,355.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.75,355.45C56.82,357.9,50.93,351.71,53,342s12.24-20.48,16.09-17.59c2.4-2.4,7.7-1.54,10.2,6.34S79.48,358.89,64.75,355.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.41,330.32a105.62,105.62,0,0,0-5.28,17.44A170.9,170.9,0,0,0,61.07,366c-1.42,11.86-1.66,11.21-1.59,23.14,0,3.3.07,6.61.13,9.91s0,6.83.31,10.22c.11,1.3,1.95.95,2-.24.11-5.94-.21-11.91-.27-17.86s0,.89.11-5A247.5,247.5,0,0,1,65,350.46c.56-3.29,1.19-6.58,2-9.83.8-3.42,1.79-6.79,2.69-10.18C69.64,330.31,69.48,330.13,69.41,330.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.41,330.32a105.62,105.62,0,0,0-5.28,17.44A170.9,170.9,0,0,0,61.07,366c-1.42,11.86-1.66,11.21-1.59,23.14,0,3.3.07,6.61.13,9.91s0,6.83.31,10.22c.11,1.3,1.95.95,2-.24.11-5.94-.21-11.91-.27-17.86s0,.89.11-5A247.5,247.5,0,0,1,65,350.46c.56-3.29,1.19-6.58,2-9.83.8-3.42,1.79-6.79,2.69-10.18C69.64,330.31,69.48,330.13,69.41,330.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,381.68c-1,5.14-8,8.84-16.18,5.48S6.07,362.67,13.39,360.35c-.4-3.84,21.74-7,32.69,6.51C54,376.67,46.4,381.68,46.4,381.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4,381.68c-1,5.14-8,8.84-16.18,5.48S6.07,362.67,13.39,360.35c-.4-3.84,21.74-7,32.69,6.51C54,376.67,46.4,381.68,46.4,381.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58,389.31a36.72,36.72,0,0,0-3.31-3.63A98.47,98.47,0,0,0,47.25,379a100.46,100.46,0,0,0-17.14-11,88.45,88.45,0,0,0-10.35-4.7c-.1,0-.06.15,0,.18,3,1.4,5.92,2.75,8.78,4.35a101.26,101.26,0,0,1,8.61,5.43,125.49,125.49,0,0,1,15.13,12.38c1.33,1.29,2.61,2.64,4,3.91s2.91,2.53,4.25,3.91c.19.2.54.11.33-.18C59.87,392,59,390.59,58,389.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,389.31a36.72,36.72,0,0,0-3.31-3.63A98.47,98.47,0,0,0,47.25,379a100.46,100.46,0,0,0-17.14-11,88.45,88.45,0,0,0-10.35-4.7c-.1,0-.06.15,0,.18,3,1.4,5.92,2.75,8.78,4.35a101.26,101.26,0,0,1,8.61,5.43,125.49,125.49,0,0,1,15.13,12.38c1.33,1.29,2.61,2.64,4,3.91s2.91,2.53,4.25,3.91c.19.2.54.11.33-.18C59.87,392,59,390.59,58,389.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.38,375.49c-.13-2.89-14.7-2.73-21.53,2.75S62.21,389.12,66.47,391c-.75,6.11,8.89,10.13,17.52,2.5S94.5,376.1,91.38,375.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.38,375.49c-.13-2.89-14.7-2.73-21.53,2.75S62.21,389.12,66.47,391c-.75,6.11,8.89,10.13,17.52,2.5S94.5,376.1,91.38,375.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,383.14a35.61,35.61,0,0,0-16.09,14.14c-.22.35.33,1,.57.65A41.64,41.64,0,0,1,77,383.23S77.09,383.11,77,383.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,383.14a35.61,35.61,0,0,0-16.09,14.14c-.22.35.33,1,.57.65A41.64,41.64,0,0,1,77,383.23S77.09,383.11,77,383.14Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34,400.38c-4.94,4.85.52,10.85,8.52,13.82s16.85,1,20.71-1,4.65-2.89,4.65-2.89-1.88-6.36-4.08-9.79A20.51,20.51,0,0,0,77,391.28C66.72,392.6,65.88,396.85,67.34,400.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.34,400.38c-4.94,4.85.52,10.85,8.52,13.82s16.85,1,20.71-1,4.65-2.89,4.65-2.89-1.88-6.36-4.08-9.79A20.51,20.51,0,0,0,77,391.28C66.72,392.6,65.88,396.85,67.34,400.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,404a52,52,0,0,0-12.54-4.64c-4.3-.83-9.58-.87-13.05,2.19-1.35,1.18-3.14,3.75-2,5.57.11.18.65.52.77.16a17.71,17.71,0,0,1,1.1-3.37A6.8,6.8,0,0,1,65,401.41a15.86,15.86,0,0,1,9.08-1.54c4.89.46,9.48,2.42,14,4.26C88.09,404.15,88.09,404,88.05,404Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,404a52,52,0,0,0-12.54-4.64c-4.3-.83-9.58-.87-13.05,2.19-1.35,1.18-3.14,3.75-2,5.57.11.18.65.52.77.16a17.71,17.71,0,0,1,1.1-3.37A6.8,6.8,0,0,1,65,401.41a15.86,15.86,0,0,1,9.08-1.54c4.89.46,9.48,2.42,14,4.26C88.09,404.15,88.09,404,88.05,404Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.69,369.85c-1.23,4.33,4.3,8.38,11.18,6.06s14-4.47,19.9-4.54,9.58-3.93,8.38-6.54-2.63-8.78-17.58-10.55-21.69,3.52-24.81,7.64S66.2,370.57,68.69,369.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.69,369.85c-1.23,4.33,4.3,8.38,11.18,6.06s14-4.47,19.9-4.54,9.58-3.93,8.38-6.54-2.63-8.78-17.58-10.55-21.69,3.52-24.81,7.64S66.2,370.57,68.69,369.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.47,360.74a18.67,18.67,0,0,0-4.83-.45,30.31,30.31,0,0,0-4.66.39,36.07,36.07,0,0,0-8.78,2.73c-5.25,2.33-10.47,5.37-13.88,10.1a33.51,33.51,0,0,0-4.4,8.24c-.2.56.88.87,1.13.37A61.73,61.73,0,0,1,64.78,375a22.41,22.41,0,0,1,5.73-6,45.59,45.59,0,0,1,15.85-7.26,31,31,0,0,1,5.06-.74,47.73,47.73,0,0,1,5.08.19C96.73,361.19,96.63,360.78,96.47,360.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.47,360.74a18.67,18.67,0,0,0-4.83-.45,30.31,30.31,0,0,0-4.66.39,36.07,36.07,0,0,0-8.78,2.73c-5.25,2.33-10.47,5.37-13.88,10.1a33.51,33.51,0,0,0-4.4,8.24c-.2.56.88.87,1.13.37A61.73,61.73,0,0,1,64.78,375a22.41,22.41,0,0,1,5.73-6,45.59,45.59,0,0,1,15.85-7.26,31,31,0,0,1,5.06-.74,47.73,47.73,0,0,1,5.08.19C96.73,361.19,96.63,360.78,96.47,360.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,394.28c-1.17-4.46-6.82-7-14.21-7.51a19.32,19.32,0,0,0-18.37,9.43c-3.86,6.6-5.47,11.86-3.12,12.72s12.27,2.24,18.68,2.81,14.4-.58,19.63-5.45S62.55,395.31,56.44,394.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,394.28c-1.17-4.46-6.82-7-14.21-7.51a19.32,19.32,0,0,0-18.37,9.43c-3.86,6.6-5.47,11.86-3.12,12.72s12.27,2.24,18.68,2.81,14.4-.58,19.63-5.45S62.55,395.31,56.44,394.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.71,393.69a19.46,19.46,0,0,0-8-.37,35.31,35.31,0,0,0-7.53,1.73,48.49,48.49,0,0,0-7.46,3.36c-1.25.68-2.48,1.41-3.68,2.18a27.77,27.77,0,0,0-3.31,2.28s0,.19,0,.15c1.21-.54,2.34-1.31,3.5-2s2.51-1.39,3.79-2a53.34,53.34,0,0,1,7.39-3.13,35.05,35.05,0,0,1,7.83-1.68,47.91,47.91,0,0,1,7.48.19C57.31,394.44,57,393.79,56.71,393.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.71,393.69a19.46,19.46,0,0,0-8-.37,35.31,35.31,0,0,0-7.53,1.73,48.49,48.49,0,0,0-7.46,3.36c-1.25.68-2.48,1.41-3.68,2.18a27.77,27.77,0,0,0-3.31,2.28s0,.19,0,.15c1.21-.54,2.34-1.31,3.5-2s2.51-1.39,3.79-2a53.34,53.34,0,0,1,7.39-3.13,35.05,35.05,0,0,1,7.83-1.68,47.91,47.91,0,0,1,7.48.19C57.31,394.44,57,393.79,56.71,393.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.38,58.26a25.33,25.33,0,0,1,11.13,15l.59,2.84A25.39,25.39,0,0,1,46.82,87.65l-.73-2.81A25.39,25.39,0,0,1,84.38,58.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.56,65.33A27.57,27.57,0,0,0,91.67,98.09l8.42,1.57a1.6,1.6,0,0,0,1.57-2.53l-5.15-6.84a27.57,27.57,0,0,0-48.95-25Zm36.82-7.07a25.33,25.33,0,0,1,11.13,15l.59,2.84A25.39,25.39,0,0,1,46.82,87.65l-.73-2.81A25.39,25.39,0,0,1,84.38,58.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,58.26a25.33,25.33,0,0,1,11.13,15l.59,2.84A25.39,25.39,0,0,1,46.82,87.65l-.73-2.81A25.39,25.39,0,0,1,84.38,58.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.79,91.7H75.2a.64.64,0,0,0,.63-.64.63.63,0,0,0-.63-.63H66.79a.63.63,0,0,0-.63.63A.64.64,0,0,0,66.79,91.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.16,93.42a.63.63,0,0,1,.63-.63H75.2a.63.63,0,0,1,.63.63,4.84,4.84,0,1,1-9.67,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,74.48a13.09,13.09,0,0,0,6.41,11.2,3.46,3.46,0,0,1,1.73,3,.57.57,0,0,0,.56.57h8.64a.53.53,0,0,0,.4-.17.59.59,0,0,0,.17-.4,3.42,3.42,0,0,1,1.73-3A13,13,0,0,0,84,74.27,13.18,13.18,0,0,0,71.62,61.48,13,13,0,0,0,58,74.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,74.48a13.09,13.09,0,0,0,6.41,11.2,3.46,3.46,0,0,1,1.73,3,.57.57,0,0,0,.56.57h8.64a.53.53,0,0,0,.4-.17.59.59,0,0,0,.17-.4,3.42,3.42,0,0,1,1.73-3A13,13,0,0,0,84,74.27,13.18,13.18,0,0,0,71.62,61.48,13,13,0,0,0,58,74.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.24,78.35a3.07,3.07,0,0,0,1.74.44,5.81,5.81,0,0,0,1-.09l.17,0,.07.15A8.85,8.85,0,0,1,68,80.51a22.68,22.68,0,0,1,.73,7.4c0,.47,0,.89,0,1.3h.67V87.94a22.9,22.9,0,0,0-.77-7.63,9.75,9.75,0,0,0-.64-1.59l-.12-.23.25-.09a7.21,7.21,0,0,0,1.88-1,8.42,8.42,0,0,0,.89-.78l.17-.17.16.17a8.42,8.42,0,0,0,.88.78,7.54,7.54,0,0,0,1.88,1l.25.09-.12.23a10.74,10.74,0,0,0-.64,1.59,23.13,23.13,0,0,0-.77,7.62c0,.44,0,.86,0,1.28h.67c0-.41,0-.83,0-1.26A22.87,22.87,0,0,1,74,80.51a9.54,9.54,0,0,1,.72-1.69l.08-.15.16,0a5.92,5.92,0,0,0,1,.09,3,3,0,0,0,1.73-.44,1,1,0,0,0,.46-1.19,1.26,1.26,0,0,0-1.26-.9,3.1,3.1,0,0,0-2.31,1.51l-.1.14-.17-.06a6.33,6.33,0,0,1-1.91-1,7,7,0,0,1-.9-.81l-.13-.13.11-.15a3.88,3.88,0,0,0,.83-3.24,1.45,1.45,0,0,0-2.74,0,4,4,0,0,0,.83,3.24l.11.15-.13.13a6.91,6.91,0,0,1-.89.81,6.26,6.26,0,0,1-1.92,1l-.16.06-.1-.14A3.11,3.11,0,0,0,65,76.26a1.25,1.25,0,0,0-1.25.9A1,1,0,0,0,64.24,78.35Zm11-.26.34-.36a2.15,2.15,0,0,1,1.41-.8.62.62,0,0,1,.63.44c.07.24-.14.38-.21.44a2.58,2.58,0,0,1-1.38.32h-.3ZM70.79,75a3,3,0,0,1-.53-2.32.78.78,0,0,1,1.47,0A3,3,0,0,1,71.19,75l-.19.33Zm-6.37,2.33a.61.61,0,0,1,.62-.43,2.2,2.2,0,0,1,1.42.8l.33.36-.49,0H66a2.62,2.62,0,0,1-1.39-.32C64.56,77.75,64.34,77.61,64.42,77.36Z",
    style: {
      fill: "#fafafa"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationI);
export default __webpack_public_path__ + "static/media/educationI.250dd0f44eb824529a2f4a8638b3e688.svg";
export { ForwardRef as ReactComponent };